import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';
import { kymw0901Handlers } from './kymw0901-handlers';
import { kymw0907Handlers } from './kymw0907-handlers';
import { kymw0908Handlers } from './kymw0908-handlers';


export const kymw09Handlers = [
  ...kymw0901Handlers,
  ...kymw0907Handlers,
  ...kymw0908Handlers,

  // 案内一覧情報取得 /kymw09/getGuideInfo
  http.post(PlessService.SERVICE.getGuideInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getGuideInfo.url, req);
    // return HttpResponse.json(getGuideInfoResponse);
    return HttpResponse.json(getGuideInfoResponseMin);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 案内一覧情報取得 /kymw09/getNextGuide
  http.post(PlessService.SERVICE.getNextGuide.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getNextGuide.url, req);
    return HttpResponse.json(getNextGuideResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品企画メンテ画面表示情報取得 /kymw09/getPlanGoodsMaintain
  http.post(PlessService.SERVICE.getPlanGoodsMaintain.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getPlanGoodsMaintain.url, req);
    return HttpResponse.json(getPlanGoodsMaintainResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 会員生協計画数取得 /kymw09/getCoopPlanNum
  http.post(PlessService.SERVICE.getCoopPlanNum.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getCoopPlanNum.url, req);
    return HttpResponse.json(getCoopPlanNumResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 注文コード割当コード一覧取得 /kymw09/getOrderNumQuotaCodeList
  http.post(PlessService.SERVICE.getOrderNumQuotaCodeList.url, async ({ request }) => {
    const req: any = await request.json();
    const reqGetType = req?.data?.search?.PlanGoodsMedium?.condition?.GetType;
    console.log(PlessService.SERVICE.getOrderNumQuotaCodeList.url, req);
    if (reqGetType && reqGetType === 'ポイント交換')
      return HttpResponse.json(getOrderNumQuotaCodeListResponseReqPoint);
    if (reqGetType && reqGetType === '1物N価媒体')
      return HttpResponse.json(getOrderNumQuotaCodeListResponseReqNval);
    if (reqGetType && reqGetType === 'クーポン')
      return HttpResponse.json(getOrderNumQuotaCodeListResponseReqCoupon);
    if (reqGetType && reqGetType === '予約商品')
      return HttpResponse.json(getOrderNumQuotaCodeListResponseReqPreOrder);
    return HttpResponse.json(getOrderNumQuotaCodeListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 抽選商品プロモーション情報取得 /kymw09/getPlanGoodsLotteryPromotion
  http.post(PlessService.SERVICE.getPlanGoodsLotteryPromotion.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getPlanGoodsLotteryPromotion.url, req);
    return HttpResponse.json(getPlanGoodsLotteryPromotionResponseFlgOn);
    // return HttpResponse.json(getPlanGoodsLotteryPromotionResponseFlgOff);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 曜日別当選数取得 /kymw09/getNumberOfUsers
  http.post(PlessService.SERVICE.getNumberOfUsers.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getNumberOfUsers.url, req);
    return HttpResponse.json(getNumberOfUsersResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // ポイント交換商品プロモーション情報取得 /kymw09/getPlanGoodsPointExchangePromotion
  http.post(PlessService.SERVICE.getPlanGoodsPointExchangePromotion.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getPlanGoodsPointExchangePromotion.url, req);
    return HttpResponse.json(getPlanGoodsPointExchangePromotionResponseFlgOn);
    // return HttpResponse.json(getPlanGoodsPointExchangePromotionResponseFlgOff);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 1物N価媒体プロモーション情報取得 /kymw09/getPlanGoodsNvalPromotion
  http.post(PlessService.SERVICE.getPlanGoodsNvalPromotion.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getPlanGoodsNvalPromotion.url, req);
    return HttpResponse.json(getPlanGoodsNvalPromotionResponseFlgOn);
    // return HttpResponse.json(getPlanGoodsNvalPromotionResponseNameNull);
    // return HttpResponse.json(getPlanGoodsNvalPromotionResponseFlgOff);
  }),

  // クーポン商品プロモーション情報取得 /kymw09/getPlanGoodsCouponPromotion
  http.post(PlessService.SERVICE.getPlanGoodsCouponPromotion.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getPlanGoodsCouponPromotion.url, req);
    return HttpResponse.json(getPlanGoodsCouponPromotionResponseFlgOn);
    // return HttpResponse.json(getPlanGoodsCouponPromotionResponseFlgOnNameNull);
    // return HttpResponse.json(getPlanGoodsCouponPromotionResponseFlgOff);
  }),

  // 予約商品フラグ取得 /kymw09/getPreOrderFlag
  http.post(PlessService.SERVICE.getPreOrderFlag.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getPreOrderFlag.url, req);
    return HttpResponse.json(getPreOrderFlagResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 予約設定情報取得 /kymw09/getPreOrder
  http.post(PlessService.SERVICE.getPreOrder.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getPreOrder.url, req);
    return HttpResponse.json(getPreOrderResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 企画商品EC情報取得処理 /kymw09/getPlanGoodsEC
  http.post(PlessService.SERVICE.getPlanGoodsEC.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getPlanGoodsEC.url, req);
    return HttpResponse.json(getPlanGoodsECResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // EC使用画像情報取得処理 /kymw09/getImageData
  http.post(PlessService.SERVICE.getImageData.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getImageData.url, req);
    return HttpResponse.json(getImageDataResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 在庫数情報取得処理 /kymw09/getStockInfo
  http.post(PlessService.SERVICE.getStockInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getStockInfo.url, req);
    return HttpResponse.json(getStockInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // グルーピング情報取得処理 /kymw09/getGroupingInfo
  http.post(PlessService.SERVICE.getGroupingInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getGroupingInfo.url, req);
    return HttpResponse.json(getGroupingInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // Webリンク情報取得処理 /kymw09/getWebLinkInfo
  http.post(PlessService.SERVICE.getWebLinkInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getWebLinkInfo.url, req);
    return HttpResponse.json(getWebLinkInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // グルーピングコード一覧取得 /kymw09/getGroupingList
  http.post(PlessService.SERVICE.KYMW09getGroupingList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW09getGroupingList.url, req);
    return HttpResponse.json(getGroupingListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // グルーピングデータ取得 /kymw09/getGroupingData
  http.post(PlessService.SERVICE.getGroupingData.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getGroupingData.url, req);
    return HttpResponse.json(getGroupingDataResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // グルーピングコード一覧取得 /kymw09/getTagList
  http.post(PlessService.SERVICE.KYMW09getTagList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW09getTagList.url, req);
    return HttpResponse.json(getTagListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品企画マスタ変更確認 /kymw09/checkPlanGoods
  http.post(PlessService.SERVICE.checkPlanGoods.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.checkPlanGoods.url, req);
    return HttpResponse.json(getCheckPlanGoodsResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 取り扱われていない生協情報取得 /kymw09/getNotUseCoop
  http.post(PlessService.SERVICE.getNotUseCoop.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getNotUseCoop.url, req);
    return HttpResponse.json(getNotUseCoopResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 取扱生協取得 /kymw09/getGoodsUseCoop
  http.post(PlessService.SERVICE.getGoodsUseCoop.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getGoodsUseCoop.url, req);
    return HttpResponse.json(getGoodsUseCoopResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  // アイコンコード取得 /kymw09/getIconData
  http.post(PlessService.SERVICE.getIconData.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getIconData.url, req);
    return HttpResponse.json(getIconDataResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

// 選定済1物N価媒体リスト取得 /kymw09/getSelectedNvalMediumList
  http.post(PlessService.SERVICE.getSelectedNvalMediumList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getSelectedNvalMediumList.url, req);
    return HttpResponse.json(getSelectedNvalMediumListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品会員生協供給価格取得 /KYMW09/getGoodsSupplyPrice
  http.post(PlessService.SERVICE.getGoodsSupplyPrice.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getGoodsSupplyPrice.url, req);
    return HttpResponse.json(getGoodsSupplyPriceResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getGuideInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      NextGuideMediumTypeList: [
        {
          MediumType: "001",
          MediumTypeName: "ハピデリ"
        },
        {
          MediumType: "003",
          MediumTypeName: "ぐるめぐり"
        },
        {
          MediumType: "006",
          MediumTypeName: "らくらくコープデリ"
        },
        {
          MediumType: "007",
          MediumTypeName: "ライフスタイル"
        },
        {
          MediumType: "023",
          MediumTypeName: "コスメｄｅきれい（ＣＤ）"
        },
        {
          MediumType: "999",
          MediumTypeName: "EC"
        }
      ],
      NextGuideInfoList: [
        {
          CoopCode: "142",
          OrderNum: "123456",
          AppearDiv: "1",
          NextGuideList: [
            {
              MediumType: "001",
              NextGuide: "毎週"
            },
            {
              MediumType: "003",
              NextGuide: "隔週"
            },
            {
              MediumType: "006",
              NextGuide: "08/01"
            },
            {
              MediumType: "007",
              NextGuide: "毎週"
            },
            {
              MediumType: "023",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
          ]
        },
        {
          CoopCode: "163",
          OrderNum: "123456",
          AppearDiv: "2",
          NextGuideList: [
            {
              MediumType: "001",
              NextGuide: "08/01"
            },
            {
              MediumType: "003",
              NextGuide: "毎週"
            },
            {
              MediumType: "006",
              NextGuide: "12/09"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
          ]
        },
        {
          CoopCode: "185",
          OrderNum: "123456",
          AppearDiv: "4",
          NextGuideList: [
            {
              MediumType: "003",
              NextGuide: "毎週"
            },
            {
              MediumType: "006",
              NextGuide: "隔週"
            },
            {
              MediumType: "007",
              NextGuide: "隔週"
            },
            {
              MediumType: "023",
              NextGuide: "隔週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
          ]
        },
        {
          CoopCode: "240",
          OrderNum: "123456",
          AppearDiv: "8",
          NextGuideList: [
            {
              MediumType: "001",
              NextGuide: "08/01"
            },
            {
              MediumType: "003",
              NextGuide: "隔週"
            },
            {
              MediumType: "006",
              NextGuide: "08/01"
            },
            {
              MediumType: "007",
              NextGuide: "毎週"
            },
            {
              MediumType: "023",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
          ]
        },
        {
          CoopCode: "210",
          OrderNum: "123456",
          AppearDiv: "2",
          NextGuideList: [
            {
              MediumType: "006",
              NextGuide: "毎週"
            },
            {
              MediumType: "007",
              NextGuide: "08/01"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
          ]
        },
        {
          CoopCode: "302",
          OrderNum: "123456",
          AppearDiv: "2",
          NextGuideList: [
            {
              MediumType: "001",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
          ]
        },
        {
          CoopCode: "515",
          OrderNum: "123456",
          AppearDiv: "2",
          NextGuideList: [
            {
              MediumType: "001",
              NextGuide: "毎週"
            },
            {
              MediumType: "003",
              NextGuide: "毎週"
            },
            {
              MediumType: "007",
              NextGuide: "毎週"
            },
            {
              MediumType: "023",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
          ]
        },
        {
          CoopCode: "451",
          OrderNum: "123456",
          AppearDiv: "2",
          NextGuideList: [
            {
              MediumType: "003",
              NextGuide: "毎週"
            },
            {
              MediumType: "007",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
          ]
        },
      ]
    }
  }
}

const getGuideInfoResponseMin = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": {
      "NextGuideMediumTypeList": [
        {
          "MediumType": "001",
          "MediumTypeName": "ハピデリ"
        },
        {
          "MediumType": "EC0",
          "MediumTypeName": "次回案内用EC媒体区分"
        }
      ],
      "NextGuideInfoList": [
        {
          "CoopCode": "142",
          "OrderNum": "",
          "AppearDiv": "",
          "NextGuideList": [
            {
              "MediumType": "001",
              "NextGuide": ""
            },
            {
              "MediumType": "EC0",
              "NextGuide": ""
            }
          ]
        },
        {
          "CoopCode": "163",
          "OrderNum": "",
          "AppearDiv": "",
          "NextGuideList": [
            {
              "MediumType": "001",
              "NextGuide": ""
            },
            {
              "MediumType": "EC0",
              "NextGuide": ""
            }
          ]
        },
        {
          "CoopCode": "185",
          "OrderNum": "",
          "AppearDiv": "",
          "NextGuideList": [
            {
              "MediumType": "001",
              "NextGuide": ""
            },
            {
              "MediumType": "EC0",
              "NextGuide": ""
            }
          ]
        },
        {
          "CoopCode": "240",
          "OrderNum": "",
          "AppearDiv": "",
          "NextGuideList": [
            {
              "MediumType": "001",
              "NextGuide": ""
            },
            {
              "MediumType": "EC0",
              "NextGuide": ""
            }
          ]
        },
        {
          "CoopCode": "210",
          "OrderNum": "",
          "AppearDiv": "",
          "NextGuideList": [
            {
              "MediumType": "001",
              "NextGuide": ""
            },
            {
              "MediumType": "EC0",
              "NextGuide": ""
            }
          ]
        },
        {
          "CoopCode": "302",
          "OrderNum": "",
          "AppearDiv": "",
          "NextGuideList": [
            {
              "MediumType": "001",
              "NextGuide": ""
            },
            {
              "MediumType": "EC0",
              "NextGuide": ""
            }
          ]
        },
        {
          "CoopCode": "515",
          "OrderNum": "",
          "AppearDiv": "",
          "NextGuideList": [
            {
              "MediumType": "001",
              "NextGuide": ""
            },
            {
              "MediumType": "EC0",
              "NextGuide": ""
            }
          ]
        },
        {
          "CoopCode": "451",
          "OrderNum": "",
          "AppearDiv": "",
          "NextGuideList": [
            {
              "MediumType": "001",
              "NextGuide": ""
            },
            {
              "MediumType": "EC0",
              "NextGuide": ""
            }
          ]
        }
      ]
    }
  }
}

const getNextGuideResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      CoopGuideList: [
        {
          CoopCode: "142",
          MediumNextGuideList: [
            {
              MediumType: "001",
              NextGuide: "毎週"
            },
            {
              MediumType: "003",
              NextGuide: "隔週"
            },
            {
              MediumType: "006",
              NextGuide: "04/01"
            },
            {
              MediumType: "007",
              NextGuide: ""
            },
            {
              MediumType: "023",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
            {
              MediumType: "EC0",
              NextGuide: "X/XX"
            },
          ]
        },
        {
          CoopCode: "163",
          MediumNextGuideList: [
            {
              MediumType: "001",
              NextGuide: "毎週"
            },
            {
              MediumType: "003",
              NextGuide: "隔週"
            },
            {
              MediumType: "006",
              NextGuide: "04/01"
            },
            {
              MediumType: "007",
              NextGuide: ""
            },
            {
              MediumType: "023",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
             {
              MediumType: "EC0",
              NextGuide: "X/XX"
            },
          ]
        },
        {
          CoopCode: "185",
          MediumNextGuideList: [
            {
              MediumType: "001",
              NextGuide: "毎週"
            },
            {
              MediumType: "003",
              NextGuide: "隔週"
            },
            {
              MediumType: "006",
              NextGuide: "04/01"
            },
            {
              MediumType: "007",
              NextGuide: ""
            },
            {
              MediumType: "023",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
             {
              MediumType: "EC0",
              NextGuide: "X/XX"
            },
          ]
        },
        {
          CoopCode: "240",
          MediumNextGuideList: [
            {
              MediumType: "001",
              NextGuide: "毎週"
            },
            {
              MediumType: "003",
              NextGuide: "隔週"
            },
            {
              MediumType: "006",
              NextGuide: "04/01"
            },
            {
              MediumType: "007",
              NextGuide: ""
            },
            {
              MediumType: "023",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
             {
              MediumType: "EC0",
              NextGuide: "X/XX"
            },
          ]
        },
        {
          CoopCode: "210",
          MediumNextGuideList: [
            {
              MediumType: "001",
              NextGuide: "毎週"
            },
            {
              MediumType: "003",
              NextGuide: "隔週"
            },
            {
              MediumType: "006",
              NextGuide: "04/01"
            },
            {
              MediumType: "007",
              NextGuide: ""
            },
            {
              MediumType: "023",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
             {
              MediumType: "EC0",
              NextGuide: "X/XX"
            },
          ]
        },
        {
          CoopCode: "302",
          MediumNextGuideList: [
            {
              MediumType: "001",
              NextGuide: "毎週"
            },
            {
              MediumType: "003",
              NextGuide: "隔週"
            },
            {
              MediumType: "006",
              NextGuide: "04/01"
            },
            {
              MediumType: "007",
              NextGuide: ""
            },
            {
              MediumType: "023",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
             {
              MediumType: "EC0",
              NextGuide: "X/XX"
            },
          ]
        },
        {
          CoopCode: "515",
          MediumNextGuideList: [
            {
              MediumType: "001",
              NextGuide: "毎週"
            },
            {
              MediumType: "003",
              NextGuide: "隔週"
            },
            {
              MediumType: "006",
              NextGuide: "04/01"
            },
            {
              MediumType: "007",
              NextGuide: ""
            },
            {
              MediumType: "023",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
             {
              MediumType: "EC0",
              NextGuide: "X/XX"
            },
          ]
        },
        {
          CoopCode: "451",
          MediumNextGuideList: [
            {
              MediumType: "001",
              NextGuide: "毎週"
            },
            {
              MediumType: "003",
              NextGuide: "隔週"
            },
            {
              MediumType: "006",
              NextGuide: "04/01"
            },
            {
              MediumType: "007",
              NextGuide: ""
            },
            {
              MediumType: "023",
              NextGuide: "毎週"
            },
            {
              MediumType: "999",
              NextGuide: "毎週"
            },
             {
              MediumType: "EC0",
              NextGuide: "X/XX"
            },
          ]
        },
      ],
      MediumTypeList: [
        {
          MediumType: "001",
          MediumTypeName: "ハピデリ"
        },
        {
          MediumType: "003",
          MediumTypeName: "ぐるめぐり"
        },
        {
          MediumType: "006",
          MediumTypeName: "らくらくコープデリ"
        },
        {
          MediumType: "007",
          MediumTypeName: "ライフスタイル"
        },
        {
          MediumType: "023",
          MediumTypeName: "コスメｄｅきれい（ＣＤ）"
        },
        {
          MediumType: "999",
          MediumTypeName: "EC"
        }
      ]
    }
  }
}

const getPlanGoodsMaintainResponse = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": {
      "getItemCodeListVO": {
        "ItemCodeList": [
          {
            "ItemCode": "1234567"
          },
          {
            "ItemCode": "2345678"
          },
          {
            "ItemCode": "3456789"
          },
        ],
        "PricePatternList": [
          {
            "CodeDiv": "ct355",
            "CodeValue": "0",
            "CodeName": "通常",
            "CodeDivName": "価格パターン",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct355",
            "CodeValue": "1",
            "CodeName": "特価１",
            "CodeDivName": "価格パターン",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct355",
            "CodeValue": "2",
            "CodeName": "特価２",
            "CodeDivName": "価格パターン",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct355",
            "CodeValue": "3",
            "CodeName": "特価３",
            "CodeDivName": "価格パターン",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          }
        ],
        "BrandTypeList": [
          {
            "CodeDiv": "ct314",
            "CodeValue": "00",
            "CodeName": "日生協",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "01",
            "CodeName": "全国共同開発",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "02",
            "CodeName": "コープデリ",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "03",
            "CodeName": "共同開発",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "04",
            "CodeName": "ＮＢ",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "05",
            "CodeName": "いばらきＰＢ",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "06",
            "CodeName": "とちぎＰＢ",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "07",
            "CodeName": "ぐんまＰＢ",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "08",
            "CodeName": "ちばＰＢ",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "09",
            "CodeName": "さいたまＰＢ",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "10",
            "CodeName": "とうきょうＰＢ",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "11",
            "CodeName": "ながのＰＢ",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "12",
            "CodeName": "産地提携品",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "13",
            "CodeName": "園地指定品",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "14",
            "CodeName": "産地指定品",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "15",
            "CodeName": "にいがたＰＢ",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "16",
            "CodeName": "クルコＰＢ",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct314",
            "CodeValue": "99",
            "CodeName": "その他",
            "CodeDivName": "ブランド区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          }
        ],
        "SetDivList": [
          {
            "CodeDiv": "ct144",
            "CodeValue": "0",
            "CodeName": "セット",
            "CodeDivName": "セット区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct144",
            "CodeValue": "1",
            "CodeName": "別積み",
            "CodeDivName": "セット区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          }
        ],
        "AssortTempDivList": [
          {
            "CodeDiv": "ct316",
            "CodeValue": "00",
            "CodeName": "冷凍",
            "CodeDivName": "仕分温度帯",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct316",
            "CodeValue": "01",
            "CodeName": "冷蔵",
            "CodeDivName": "仕分温度帯",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct316",
            "CodeValue": "02",
            "CodeName": "常温",
            "CodeDivName": "仕分温度帯",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct316",
            "CodeValue": "03",
            "CodeName": "青果",
            "CodeDivName": "仕分温度帯",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          }
        ],
        "OrderNumQuota": [
          {
            "CoopCode": "142",
            "OrderNumQuotaCode": "001",
            "OrderNumQuotaName": "ハピデリＯＣＲ",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "142",
            "OrderNumQuotaCode": "002",
            "OrderNumQuotaName": "ハピデリ４桁（翌週）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "142",
            "OrderNumQuotaCode": "003",
            "OrderNumQuotaName": "ハピデリ（翌々週）",
            "DeliveryWeekFixFlag": "02",
            "DelivCatalogID": "20231101"
          },
          {
            "CoopCode": "142",
            "OrderNumQuotaCode": "004",
            "OrderNumQuotaName": "本誌予備",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "142",
            "OrderNumQuotaCode": "012",
            "OrderNumQuotaName": "都県別（いばらき）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "142",
            "OrderNumQuotaCode": "052",
            "OrderNumQuotaName": "都県別ＯＣＲ（いばらき）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "142",
            "OrderNumQuotaCode": "703",
            "OrderNumQuotaName": "セット商品用（予約）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "163",
            "OrderNumQuotaCode": "001",
            "OrderNumQuotaName": "ハピデリＯＣＲ",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "163",
            "OrderNumQuotaCode": "002",
            "OrderNumQuotaName": "ハピデリ４桁（翌週）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "163",
            "OrderNumQuotaCode": "003",
            "OrderNumQuotaName": "ハピデリ（翌々週）",
            "DeliveryWeekFixFlag": "02",
            "DelivCatalogID": "20231101"
          },
          {
            "CoopCode": "163",
            "OrderNumQuotaCode": "004",
            "OrderNumQuotaName": "本誌予備",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "163",
            "OrderNumQuotaCode": "013",
            "OrderNumQuotaName": "都県別（とちぎ）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "163",
            "OrderNumQuotaCode": "053",
            "OrderNumQuotaName": "都県別ＯＣＲ（とちぎ）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "163",
            "OrderNumQuotaCode": "703",
            "OrderNumQuotaName": "セット商品用（予約）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "185",
            "OrderNumQuotaCode": "001",
            "OrderNumQuotaName": "ハピデリＯＣＲ",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "185",
            "OrderNumQuotaCode": "002",
            "OrderNumQuotaName": "ハピデリ４桁（翌週）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "185",
            "OrderNumQuotaCode": "003",
            "OrderNumQuotaName": "ハピデリ（翌々週）",
            "DeliveryWeekFixFlag": "02",
            "DelivCatalogID": "20231101"
          },
          {
            "CoopCode": "185",
            "OrderNumQuotaCode": "004",
            "OrderNumQuotaName": "本誌予備",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "185",
            "OrderNumQuotaCode": "014",
            "OrderNumQuotaName": "都県別（ぐんま）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "185",
            "OrderNumQuotaCode": "054",
            "OrderNumQuotaName": "都県別ＯＣＲ（ぐんま）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "185",
            "OrderNumQuotaCode": "703",
            "OrderNumQuotaName": "セット商品用（予約）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "240",
            "OrderNumQuotaCode": "001",
            "OrderNumQuotaName": "ハピデリＯＣＲ",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "240",
            "OrderNumQuotaCode": "002",
            "OrderNumQuotaName": "ハピデリ４桁（翌週）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "240",
            "OrderNumQuotaCode": "003",
            "OrderNumQuotaName": "ハピデリ（翌々週）",
            "DeliveryWeekFixFlag": "02",
            "DelivCatalogID": "20231101"
          },
          {
            "CoopCode": "240",
            "OrderNumQuotaCode": "004",
            "OrderNumQuotaName": "本誌予備",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "240",
            "OrderNumQuotaCode": "015",
            "OrderNumQuotaName": "都県別（ちば）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "240",
            "OrderNumQuotaCode": "055",
            "OrderNumQuotaName": "都県別ＯＣＲ（ちば）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "240",
            "OrderNumQuotaCode": "703",
            "OrderNumQuotaName": "セット商品用（予約）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "210",
            "OrderNumQuotaCode": "001",
            "OrderNumQuotaName": "ハピデリＯＣＲ",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "210",
            "OrderNumQuotaCode": "002",
            "OrderNumQuotaName": "ハピデリ４桁（翌週）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "210",
            "OrderNumQuotaCode": "003",
            "OrderNumQuotaName": "ハピデリ（翌々週）",
            "DeliveryWeekFixFlag": "02",
            "DelivCatalogID": "20231101"
          },
          {
            "CoopCode": "210",
            "OrderNumQuotaCode": "004",
            "OrderNumQuotaName": "本誌予備",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "210",
            "OrderNumQuotaCode": "016",
            "OrderNumQuotaName": "都県別（さいたま）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "210",
            "OrderNumQuotaCode": "056",
            "OrderNumQuotaName": "都県別ＯＣＲ（さいたま）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "210",
            "OrderNumQuotaCode": "703",
            "OrderNumQuotaName": "セット商品用（予約）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "302",
            "OrderNumQuotaCode": "001",
            "OrderNumQuotaName": "ハピデリＯＣＲ",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "302",
            "OrderNumQuotaCode": "002",
            "OrderNumQuotaName": "ハピデリ４桁（翌週）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "302",
            "OrderNumQuotaCode": "003",
            "OrderNumQuotaName": "ハピデリ（翌々週）",
            "DeliveryWeekFixFlag": "02",
            "DelivCatalogID": "20231101"
          },
          {
            "CoopCode": "302",
            "OrderNumQuotaCode": "004",
            "OrderNumQuotaName": "本誌予備",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "302",
            "OrderNumQuotaCode": "017",
            "OrderNumQuotaName": "都県別（とうきょう）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "302",
            "OrderNumQuotaCode": "057",
            "OrderNumQuotaName": "都県別ＯＣＲ（とうきょう）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "302",
            "OrderNumQuotaCode": "703",
            "OrderNumQuotaName": "セット商品用（予約）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "515",
            "OrderNumQuotaCode": "001",
            "OrderNumQuotaName": "ハピデリＯＣＲ",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "515",
            "OrderNumQuotaCode": "002",
            "OrderNumQuotaName": "ハピデリ４桁（翌週）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "515",
            "OrderNumQuotaCode": "003",
            "OrderNumQuotaName": "ハピデリ（翌々週）",
            "DeliveryWeekFixFlag": "02",
            "DelivCatalogID": "20231101"
          },
          {
            "CoopCode": "515",
            "OrderNumQuotaCode": "004",
            "OrderNumQuotaName": "本誌予備",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "515",
            "OrderNumQuotaCode": "018",
            "OrderNumQuotaName": "都県別（ながの）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "515",
            "OrderNumQuotaCode": "058",
            "OrderNumQuotaName": "都県別ＯＣＲ（ながの）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "515",
            "OrderNumQuotaCode": "703",
            "OrderNumQuotaName": "セット商品用（予約）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "451",
            "OrderNumQuotaCode": "001",
            "OrderNumQuotaName": "ハピデリＯＣＲ",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "451",
            "OrderNumQuotaCode": "002",
            "OrderNumQuotaName": "ハピデリ４桁（翌週）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "451",
            "OrderNumQuotaCode": "003",
            "OrderNumQuotaName": "ハピデリ（翌々週）",
            "DeliveryWeekFixFlag": "02",
            "DelivCatalogID": "20231101"
          },
          {
            "CoopCode": "451",
            "OrderNumQuotaCode": "004",
            "OrderNumQuotaName": "本誌予備",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "451",
            "OrderNumQuotaCode": "019",
            "OrderNumQuotaName": "都県別（にいがた）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "451",
            "OrderNumQuotaCode": "059",
            "OrderNumQuotaName": "都県別ＯＣＲ（にいがた）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "451",
            "OrderNumQuotaCode": "703",
            "OrderNumQuotaName": "セット商品用（予約）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "454",
            "OrderNumQuotaCode": "001",
            "OrderNumQuotaName": "ハピデリＯＣＲ",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "454",
            "OrderNumQuotaCode": "002",
            "OrderNumQuotaName": "ハピデリ４桁（翌週）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "454",
            "OrderNumQuotaCode": "003",
            "OrderNumQuotaName": "ハピデリ（翌々週）",
            "DeliveryWeekFixFlag": "02",
            "DelivCatalogID": "20231101"
          },
          {
            "CoopCode": "454",
            "OrderNumQuotaCode": "004",
            "OrderNumQuotaName": "本誌予備",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          },
          {
            "CoopCode": "454",
            "OrderNumQuotaCode": "703",
            "OrderNumQuotaName": "セット商品用（予約）",
            "DeliveryWeekFixFlag": "01",
            "DelivCatalogID": "20231004"
          }
        ],
        "ApperDivList": [
          {
            "CodeDiv": "ct363",
            "CodeValue": "1",
            "CodeName": "新登場",
            "CodeDivName": "登場区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct363",
            "CodeValue": "2",
            "CodeName": "シーズン初",
            "CodeDivName": "登場区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct363",
            "CodeValue": "3",
            "CodeName": "シーズン最後",
            "CodeDivName": "登場区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct363",
            "CodeValue": "4",
            "CodeName": "リニューアル新登場",
            "CodeDivName": "登場区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct363",
            "CodeValue": "5",
            "CodeName": "今回限り",
            "CodeDivName": "登場区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct363",
            "CodeValue": "6",
            "CodeName": "今回終了",
            "CodeDivName": "登場区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct363",
            "CodeValue": "7",
            "CodeName": "年内最終",
            "CodeDivName": "登場区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct363",
            "CodeValue": "8",
            "CodeName": "パッケージリニューアル",
            "CodeDivName": "登場区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          },
          {
            "CodeDiv": "ct363",
            "CodeValue": "9",
            "CodeName": "次回リニューアル",
            "CodeDivName": "登場区分",
            "Reserve1": "",
            "Reserve2": "",
            "ReserveNum1": null,
            "ReserveNum2": null,
            "SortNum": null,
            "StartOrderCode": "",
            "EndOrderCode": ""
          }
        ]
      },
      "getPlanGoodsBaseVO": {
        "PCodeCommon": {
          "OrderCode": "2023320",
          "BuyerCode": "00200004:土屋",
          "ClassDivNum": "2",
          "PackMaterialShowFlg": "1",
          "ClassCode": "02",
          "LargeClassCode": "08",
          "MiddleClassCode": "0800",
          "SmallClassCode": "080009",
          "DataType": "00",
          "GuideGoodsName": "北海道３種の海鮮丼",
          "GuideStandardName": "１００ｇ（５０ｇ×２）",
          "MediumType": "001",
          "AdmitStatus": "2",
          "RegistDate": "2023年07月06日 10:22:38",
          "DutiesFormDiv": "1",
          "PCode": "P2670878",
          "UpdateData": "2023年07月06日 11:45:32"
        },
        "PCodeBase": {
          "DeliveryGoodsNameKanji": "北海道３種の海鮮丼",
          "DeliveryStandardNameKanji": "５０ｇ×２",
          "DeliveryGoodsNameKana": "ﾎｯｶｲﾄﾞｳ3ｼｭﾉｶｲｾﾝ",
          "DeliveryStandardNameKana": "100G",
          "OcrGoodsName": "北海道３種海鮮丼",
          "ConsumeTaxDiv": "0",
          "ConsumeTaxRate": 8,
          "DefaultConsumeTaxDiv": "0 ",
          "DefaultConsumeTaxRate": 8,
          "CycleTerm": "",
          "EdlpDiv": "0",
          "UnitPriceDiv": "0",
          "UnitPriceCoefficient": 0,
          "UnitPriceUnit": "",
          "ConsumeTerm": 365,
          "ConsumeByDate": 0,
          "LeaveConsumeTerm": 0,
          "GuideTempZoneDiv": "00",
          "RelationPCodeOld": "",
          "RelationPCodeNew": "",
          "BlindDiv": "",
          "EFriendsSendDiv": "0",
          "KomaScheduleDiv": "",
          "LiquorCode": "",
          "AlocoholType": 0,
          "ContainerForm": "",
          "ContainerCapacity": 0,
          "BackgroundColorOrderCode": "2023320"
        },
        "PCodeCoop": {
          "RegularFlg": 1,
          // "RegularFlg": 0,
          "PricePatternLinkMarkList": [
            {
              "PricePatternLinkMarkCode": 1,
              "PricePatternLinkMarkName": "９９：表紙掲載"
            },
            {
              "PricePatternLinkMarkCode": 2,
              "PricePatternLinkMarkName": "９９：今週のおすすめ"
            },
            {
              "PricePatternLinkMarkCode": 5,
              "PricePatternLinkMarkName": "９９：スーパープライス"
            },
            {
              "PricePatternLinkMarkCode": 10,
              "PricePatternLinkMarkName": "９９：裏表紙掲載商品"
            },
            {
              "PricePatternLinkMarkCode": 999,
              "PricePatternLinkMarkName": "９９：催事価格"
            }
          ],
          "CoopSystemMarkList": [
            {
              "CoopCode": "142",
              "PlanCoopName": "いばらき",
              "CoopShortName": "い",
              "SystemMark1": "0",
              "SystemMark2": "0",
              "SystemMark3": "0",
              "SystemMark4": "0",
              "SystemMark5": "0",
              "DealCoopDiv": "1"
            },
            {
              "CoopCode": "163",
              "PlanCoopName": "とちぎ",
              "CoopShortName": "と",
              "SystemMark1": "0",
              "SystemMark2": "0",
              "SystemMark3": "0",
              "SystemMark4": "0",
              "SystemMark5": "0",
              "DealCoopDiv": "1"
            },
            {
              "CoopCode": "185",
              "PlanCoopName": "ぐんま",
              "CoopShortName": "ぐ",
              "SystemMark1": "0",
              "SystemMark2": "0",
              "SystemMark3": "0",
              "SystemMark4": "0",
              "SystemMark5": "0",
              "DealCoopDiv": "1"
            },
            {
              "CoopCode": "240",
              "PlanCoopName": "ちば",
              "CoopShortName": "ち",
              "SystemMark1": "0",
              "SystemMark2": "0",
              "SystemMark3": "0",
              "SystemMark4": "0",
              "SystemMark5": "0",
              "DealCoopDiv": "1"
            },
            {
              "CoopCode": "210",
              "PlanCoopName": "さいたま",
              "CoopShortName": "さ",
              "SystemMark1": "0",
              "SystemMark2": "0",
              "SystemMark3": "0",
              "SystemMark4": "0",
              "SystemMark5": "0",
              "DealCoopDiv": "1"
            },
            {
              "CoopCode": "302",
              "PlanCoopName": "とうきょう",
              "CoopShortName": "とう",
              "SystemMark1": "0",
              "SystemMark2": "0",
              "SystemMark3": "0",
              "SystemMark4": "0",
              "SystemMark5": "0",
              "DealCoopDiv": "1"
            },
            {
              "CoopCode": "515",
              "PlanCoopName": "ながの",
              "CoopShortName": "な",
              "SystemMark1": "0",
              "SystemMark2": "0",
              "SystemMark3": "0",
              "SystemMark4": "0",
              "SystemMark5": "0",
              "DealCoopDiv": "1"
            },
            {
              "CoopCode": "451",
              "PlanCoopName": "にいがた",
              "CoopShortName": "に",
              "SystemMark1": "0",
              "SystemMark2": "0",
              "SystemMark3": "0",
              "SystemMark4": "0",
              "SystemMark5": "0",
              "DealCoopDiv": "1"
            }
          ],
          "CoopPriceList": [
            {
              "ItemCode": "1234567",
              "PricePatern": "0",
              "SupplyPriceCoefficient": 398,
              "SupplyPriceSpecial1": 380,
              "SupplyPriceSpecial2": 358,
              "ThisTimeSupplyPrice": 398,
              "CostPriceCoefficient": 245,
              "CostPriceSpecial1": 245,
              "CostPriceSpecial2": 245,
              "ThisTimeCostPrice": 245,
              "PromotionDiv": "-",
              "CostPrice": 245,
              "EnableMode": "true",
              "UseRegularFlg": "1"
            },
            {
              "ItemCode": "1234567",
              "PricePatern": "0",
              "SupplyPriceCoefficient": 398,
              "SupplyPriceSpecial1": 380,
              "SupplyPriceSpecial2": 358,
              "ThisTimeSupplyPrice": 398,
              "CostPriceCoefficient": 245,
              "CostPriceSpecial1": 245,
              "CostPriceSpecial2": 245,
              "ThisTimeCostPrice": 245,
              "PromotionDiv": "-",
              "CostPrice": 245,
              "EnableMode": "true",
              "UseRegularFlg": "1"
            },
            {
              "ItemCode": "1234567",
              "PricePatern": "0",
              "SupplyPriceCoefficient": 398,
              "SupplyPriceSpecial1": 380,
              "SupplyPriceSpecial2": 358,
              "ThisTimeSupplyPrice": 398,
              "CostPriceCoefficient": 245,
              "CostPriceSpecial1": 245,
              "CostPriceSpecial2": 245,
              "ThisTimeCostPrice": 245,
              "PromotionDiv": "-",
              "CostPrice": 245,
              "EnableMode": "true",
              "UseRegularFlg": "1"
            },
            {
              "ItemCode": "2345678",
              "PricePatern": "0",
              "SupplyPriceCoefficient": 398,
              "SupplyPriceSpecial1": 380,
              "SupplyPriceSpecial2": 358,
              "ThisTimeSupplyPrice": 398,
              "CostPriceCoefficient": 245,
              "CostPriceSpecial1": 245,
              "CostPriceSpecial2": 245,
              "ThisTimeCostPrice": 245,
              "PromotionDiv": "-",
              "CostPrice": 245,
              "EnableMode": "true",
              "UseRegularFlg": "1"
            },
            {
              "ItemCode": "1234567",
              "PricePatern": "0",
              "SupplyPriceCoefficient": 398,
              "SupplyPriceSpecial1": 380,
              "SupplyPriceSpecial2": 358,
              "ThisTimeSupplyPrice": 398,
              "CostPriceCoefficient": 245,
              "CostPriceSpecial1": 245,
              "CostPriceSpecial2": 245,
              "ThisTimeCostPrice": 245,
              "PromotionDiv": "-",
              "CostPrice": 245,
              "EnableMode": "true",
              "UseRegularFlg": "1"
            },
            {
              "ItemCode": "1234567",
              "PricePatern": "0",
              "SupplyPriceCoefficient": 398.0,
              "SupplyPriceSpecial1": 380.0,
              "SupplyPriceSpecial2": 358.0,
              "ThisTimeSupplyPrice": 398,
              "CostPriceCoefficient": 245.0,
              "CostPriceSpecial1": 245.0,
              "CostPriceSpecial2": 245.0,
              "ThisTimeCostPrice": 245,
              "PromotionDiv": "-",
              "CostPrice": 245,
              "EnableMode": "true",
              "UseRegularFlg": "1"
            },
            {
              "ItemCode": "1234567",
              "PricePatern": "0",
              "SupplyPriceCoefficient": 398.0,
              "SupplyPriceSpecial1": 380.0,
              "SupplyPriceSpecial2": 358.0,
              "ThisTimeSupplyPrice": 398,
              "CostPriceCoefficient": 245.0,
              "CostPriceSpecial1": 245.0,
              "CostPriceSpecial2": 245.0,
              "ThisTimeCostPrice": 245,
              "PromotionDiv": "-",
              "CostPrice": 245,
              "EnableMode": "true",
              "UseRegularFlg": "1"
            },
            {
              "ItemCode": "1234567",
              "PricePatern": "0",
              "SupplyPriceCoefficient": 398.0,
              "SupplyPriceSpecial1": 380.0,
              "SupplyPriceSpecial2": 358.0,
              "ThisTimeSupplyPrice": 398,
              "CostPriceCoefficient": 245.0,
              "CostPriceSpecial1": 245.0,
              "CostPriceSpecial2": 245.0,
              "ThisTimeCostPrice": 245,
              "PromotionDiv": "-",
              "CostPrice": 245,
              "EnableMode": "true",
              "UseRegularFlg": "1"
            }
          ]
        },
        "PCodeDetail": {
          "CoopInfoList": [
            {
              "CoopCode": "142",
              "PlanCoopName": "いばらき",
              "BrandType": "04",
              "SetDiv": "0",
              "AssortTempDiv": "00",
              "OrderNumQuotaCode": "001",
              "ProducingAreaComment1": "",
              "ProducingAreaComment2": "",
              "DetailUseRegularFlg": "0",
            },
            {
              "CoopCode": "163",
              "PlanCoopName": "とちぎ",
              "BrandType": "04",
              "SetDiv": "0",
              "AssortTempDiv": "00",
              "OrderNumQuotaCode": "001",
              "ProducingAreaComment1": "",
              "ProducingAreaComment2": "",
              "DetailUseRegularFlg": "1",
            },
            {
              "CoopCode": "185",
              "PlanCoopName": "ぐんま",
              "BrandType": "04",
              "SetDiv": "0",
              "AssortTempDiv": "00",
              "OrderNumQuotaCode": "001",
              "ProducingAreaComment1": "",
              "ProducingAreaComment2": "",
              "DetailUseRegularFlg": "1",
            },
            {
              "CoopCode": "240",
              "PlanCoopName": "ちば",
              "BrandType": "04",
              "SetDiv": "0",
              "AssortTempDiv": "00",
              "OrderNumQuotaCode": "001",
              "ProducingAreaComment1": "",
              "ProducingAreaComment2": "",
              "DetailUseRegularFlg": "0",
            },
            {
              "CoopCode": "210",
              "PlanCoopName": "さいたま",
              "BrandType": "04",
              "SetDiv": "0",
              "AssortTempDiv": "00",
              "OrderNumQuotaCode": "001",
              "ProducingAreaComment1": "",
              "ProducingAreaComment2": "",
              "DetailUseRegularFlg": "1",
            },
            {
              "CoopCode": "302",
              "PlanCoopName": "とうきょう",
              "BrandType": "04",
              "SetDiv": "0",
              "AssortTempDiv": "00",
              "OrderNumQuotaCode": "001",
              "ProducingAreaComment1": "",
              "ProducingAreaComment2": "",
              "DetailUseRegularFlg": "0",
            },
            {
              "CoopCode": "515",
              "PlanCoopName": "ながの",
              "BrandType": "04",
              "SetDiv": "0",
              "AssortTempDiv": "00",
              "OrderNumQuotaCode": "001",
              "ProducingAreaComment1": "",
              "ProducingAreaComment2": "",
              "DetailUseRegularFlg": "1",
            },
            {
              "CoopCode": "451",
              "PlanCoopName": "にいがた",
              "BrandType": "04",
              "SetDiv": "0",
              "AssortTempDiv": "00",
              "OrderNumQuotaCode": "001",
              "ProducingAreaComment1": "",
              "ProducingAreaComment2": "",
              "DetailUseRegularFlg": "0",
            }
          ],
          "ListingGoodsName": "",
          "ListingItemList": [
            {
              "DispContents": "",
              "ListingItemID": "I01",
              "ListingItemName": "種類"
            },
            {
              "DispContents": "",
              "ListingItemID": "I02",
              "ListingItemName": "内容量"
            },
            {
              "DispContents": "",
              "ListingItemID": "I03",
              "ListingItemName": "サイズ"
            },
            {
              "DispContents": "",
              "ListingItemID": "I04",
              "ListingItemName": "サイズ（cm）"
            },
            {
              "DispContents": "",
              "ListingItemID": "I05",
              "ListingItemName": "シートサイズ"
            },
            {
              "DispContents": "",
              "ListingItemID": "I06",
              "ListingItemName": "シートサイズ（cm）"
            },
            {
              "DispContents": "",
              "ListingItemID": "I07",
              "ListingItemName": "ヒップサイズ"
            },
            {
              "DispContents": "",
              "ListingItemID": "I08",
              "ListingItemName": "商品サイズ（cm）"
            },
            {
              "DispContents": "",
              "ListingItemID": "I09",
              "ListingItemName": "最小通過径"
            },
            {
              "DispContents": "",
              "ListingItemID": "I10",
              "ListingItemName": "手の平周り"
            },
            {
              "DispContents": "",
              "ListingItemID": "I11",
              "ListingItemName": "中指の長"
            },
            {
              "DispContents": "",
              "ListingItemID": "I12",
              "ListingItemName": "プランド"
            },
            {
              "DispContents": "",
              "ListingItemID": "I13",
              "ListingItemName": "適用体重"
            },
            {
              "DispContents": "",
              "ListingItemID": "I14",
              "ListingItemName": "枚数"
            },
            {
              "DispContents": "",
              "ListingItemID": "I15",
              "ListingItemName": "パンツ・テープ"
            },
            {
              "DispContents": "",
              "ListingItemID": "I16",
              "ListingItemName": "吸収量"
            },
            {
              "DispContents": "",
              "ListingItemID": "I17",
              "ListingItemName": "厚さ"
            },
            {
              "DispContents": "",
              "ListingItemID": "I18",
              "ListingItemName": "ウエスト（cm）"
            }
          ]
        },
        "PCodeMark": {
          "GoodsMarkList": [
            {
              "GoodsMarkCode": 27,
              "GoodsMarkName": "０２：冷暗所保存（農産）",
              "GoodsMarkGroupCode": "12",
              "GoodsMark": "0",
              "GoodsMarkCaption": "農産"
            },
            {
              "GoodsMarkCode": 36,
              "GoodsMarkName": "０１：増量",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 103,
              "GoodsMarkName": "９９：おいしさシリーズ",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 105,
              "GoodsMarkName": "９９：健康シリーズ",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 106,
              "GoodsMarkName": "９９：人気ベスト１",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 107,
              "GoodsMarkName": "９９：人気ベスト２",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 108,
              "GoodsMarkName": "９９：人気ベスト３",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 111,
              "GoodsMarkName": "９９：忘れず注文",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 112,
              "GoodsMarkName": "９９：在庫限定わけあり",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 119,
              "GoodsMarkName": "９９：コープベーシック",
              "GoodsMarkGroupCode": "09",
              "GoodsMark": "0",
              "GoodsMarkCaption": "ブランド"
            },
            {
              "GoodsMarkCode": 120,
              "GoodsMarkName": "９９：組合員共同開発商品",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 121,
              "GoodsMarkName": "９９：コープデリ限定",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 122,
              "GoodsMarkName": "９９：生協限定",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 123,
              "GoodsMarkName": "９９：コープデリセレクション",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 124,
              "GoodsMarkName": "９９：ＣＯＯＰクオリティ",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 125,
              "GoodsMarkName": "９９：国産素材",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 126,
              "GoodsMarkName": "９９：包材変更可能性あり",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 127,
              "GoodsMarkName": "９９：離乳食　５・６カ月",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 128,
              "GoodsMarkName": "９９：離乳食　７・８カ月",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 129,
              "GoodsMarkName": "９９：離乳食　９～１１カ月",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 130,
              "GoodsMarkName": "９９：離乳食　１２～１８カ月",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 131,
              "GoodsMarkName": "９９：離乳食　１８カ月頃から",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 132,
              "GoodsMarkName": "９９：離乳食　２歳頃から",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 133,
              "GoodsMarkName": "９９：離乳食　３歳頃から",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 134,
              "GoodsMarkName": "９９：キャラクター商品",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 135,
              "GoodsMarkName": "９９：スチームパック",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 136,
              "GoodsMarkName": "９９：鉄分",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 137,
              "GoodsMarkName": "９９：葉酸",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 138,
              "GoodsMarkName": "９９：カルシウム",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 139,
              "GoodsMarkName": "９９：モーハウス",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 140,
              "GoodsMarkName": "９９：ＥＣ大容量（スープ・お味噌汁）",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 141,
              "GoodsMarkName": "９９：ママ向けスイーツ",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 142,
              "GoodsMarkName": "９９：ＥＣアレルギー対応食品",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 143,
              "GoodsMarkName": "９９：ＥＣベビー",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 144,
              "GoodsMarkName": "９９：ＥＣ介護おむつ",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 145,
              "GoodsMarkName": "９９：ＥＣベビー菓子",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 146,
              "GoodsMarkName": "９９：ＥＣベビー冷食",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 147,
              "GoodsMarkName": "９９：ＥＣベビー食品飲料",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 148,
              "GoodsMarkName": "９９：ＥＣ大容量（冷食）",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 149,
              "GoodsMarkName": "９９：ＥＣ大容量（調味ジャム粉類）",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 151,
              "GoodsMarkName": "９９：調理電子レンジ",
              "GoodsMarkGroupCode": "04",
              "GoodsMark": "0",
              "GoodsMarkCaption": "調理"
            },
            {
              "GoodsMarkCode": 152,
              "GoodsMarkName": "９９：調理お湯",
              "GoodsMarkGroupCode": "04",
              "GoodsMark": "0",
              "GoodsMarkCaption": "調理"
            },
            {
              "GoodsMarkCode": 153,
              "GoodsMarkName": "９９：調理油",
              "GoodsMarkGroupCode": "04",
              "GoodsMark": "0",
              "GoodsMarkCaption": "調理"
            },
            {
              "GoodsMarkCode": 154,
              "GoodsMarkName": "９９：調理オーブントースター",
              "GoodsMarkGroupCode": "04",
              "GoodsMark": "0",
              "GoodsMarkCaption": "調理"
            },
            {
              "GoodsMarkCode": 155,
              "GoodsMarkName": "９９：調理自然解凍",
              "GoodsMarkGroupCode": "04",
              "GoodsMark": "0",
              "GoodsMarkCaption": "調理"
            },
            {
              "GoodsMarkCode": 156,
              "GoodsMarkName": "９９：調理蒸す",
              "GoodsMarkGroupCode": "04",
              "GoodsMark": "0",
              "GoodsMarkCaption": "調理"
            },
            {
              "GoodsMarkCode": 157,
              "GoodsMarkName": "９９：フライパン",
              "GoodsMarkGroupCode": "04",
              "GoodsMark": "0",
              "GoodsMarkCaption": "調理"
            },
            {
              "GoodsMarkCode": 158,
              "GoodsMarkName": "９９：調理オーブン",
              "GoodsMarkGroupCode": "04",
              "GoodsMark": "0",
              "GoodsMarkCaption": "調理"
            },
            {
              "GoodsMarkCode": 159,
              "GoodsMarkName": "９９：調理煮る",
              "GoodsMarkGroupCode": "04",
              "GoodsMark": "0",
              "GoodsMarkCaption": "調理"
            },
            {
              "GoodsMarkCode": 162,
              "GoodsMarkName": "９９：洗濯表示　ドライ",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 163,
              "GoodsMarkName": "９９：洗濯表示　手洗い",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 164,
              "GoodsMarkName": "９９：洗濯表示　手洗いドライ不可",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 165,
              "GoodsMarkName": "９９：洗濯表示　洗濯機",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 166,
              "GoodsMarkName": "９９：洗濯表示　洗濯機ドライ不可",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 167,
              "GoodsMarkName": "９９：ＥＣ減塩",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 168,
              "GoodsMarkName": "９９：ＥＣ糖質オフ",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 169,
              "GoodsMarkName": "９９：冷蔵解凍",
              "GoodsMarkGroupCode": "04",
              "GoodsMark": "0",
              "GoodsMarkCaption": "調理"
            },
            {
              "GoodsMarkCode": 170,
              "GoodsMarkName": "９９：ＥＣ介護食",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 171,
              "GoodsMarkName": "９９：ＥＣそろってＧｏｏｄ！",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 172,
              "GoodsMarkName": "９９：ＥＣぐるめでＧｏｏｄ！",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 173,
              "GoodsMarkName": "９９：ＥＣ産直Ｇｏｈａｎ",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 174,
              "GoodsMarkName": "９９：ＥＣすこやかＤｉｓｈ",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 175,
              "GoodsMarkName": "９９：ＥＣ副菜付き",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 176,
              "GoodsMarkName": "９９：セット企画　レシピセット",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 177,
              "GoodsMarkName": "９９：セット企画　ミールキット",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 178,
              "GoodsMarkName": "９９：セット企画　おまけ・紙袋つき",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 179,
              "GoodsMarkName": "９９：セット企画　レシピなしセット",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 184,
              "GoodsMarkName": "９９：ＥＣペット療法食　",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 190,
              "GoodsMarkName": "９９：機能性表示食品",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 191,
              "GoodsMarkName": "９９：ＥＣ　Ｗｏｒｌｄ　Ｄｉｓｈ",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 192,
              "GoodsMarkName": "９９：ＥＣ　＋１Ｄａｙミールキット",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 193,
              "GoodsMarkName": "９９：ＥＣ　ボリュームキット",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 194,
              "GoodsMarkName": "９９：ＥＣ　冷凍ミールキット",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 201,
              "GoodsMarkName": "９９：特別栽培農産物",
              "GoodsMarkGroupCode": "12",
              "GoodsMark": "0",
              "GoodsMarkCaption": "農産"
            },
            {
              "GoodsMarkCode": 202,
              "GoodsMarkName": "９９：無洗米",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 203,
              "GoodsMarkName": "９９：胚芽精米",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 204,
              "GoodsMarkName": "９９：普通精米",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 205,
              "GoodsMarkName": "９９：特定保健用食品",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 206,
              "GoodsMarkName": "９９：有機ＪＡＳ",
              "GoodsMarkGroupCode": "12",
              "GoodsMark": "0",
              "GoodsMarkCaption": "農産"
            },
            {
              "GoodsMarkCode": 207,
              "GoodsMarkName": "９９：ＭＳＣ認証（短説明）",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 208,
              "GoodsMarkName": "９９：冷蔵肉",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 209,
              "GoodsMarkName": "９９：ＧＰ特栽",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 210,
              "GoodsMarkName": "９９：ＧＰ有機",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 211,
              "GoodsMarkName": "９９：たべるつたえる",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 213,
              "GoodsMarkName": "９９：みのりたまご",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 215,
              "GoodsMarkName": "９９：玄米",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 216,
              "GoodsMarkName": "９９：米小量規格",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 221,
              "GoodsMarkName": "９９：骨ぬき",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 222,
              "GoodsMarkName": "９９：バラ凍結",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 225,
              "GoodsMarkName": "９９：美ら島",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 226,
              "GoodsMarkName": "９９： 佐渡トキ",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 228,
              "GoodsMarkName": "９９：BAP認証",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 229,
              "GoodsMarkName": "９９：RFM認証",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 230,
              "GoodsMarkName": "９９：冷蔵フレッシュパック",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 232,
              "GoodsMarkName": "９９：ＡＳＣ認証",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 233,
              "GoodsMarkName": "９９：ＡＳＣ認証縦版",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 234,
              "GoodsMarkName": "９９：ＭＥＬ認証",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 235,
              "GoodsMarkName": "９９：ＥＣ　ＦＳＣ認証商品",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 236,
              "GoodsMarkName": "９９：ＥＣ　レインフォレスト・アライアンス",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 237,
              "GoodsMarkName": "９９：ＥＣ　エコマーク商品",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 301,
              "GoodsMarkName": "９９：氷菓",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 302,
              "GoodsMarkName": "９９：ラクトアイス",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 303,
              "GoodsMarkName": "９９：アイスミルク",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 304,
              "GoodsMarkName": "９９：アイスクリーム",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 351,
              "GoodsMarkName": "９９：辛口タイプ",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 352,
              "GoodsMarkName": "９９：中辛口タイプ",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 353,
              "GoodsMarkName": "９９：中甘口タイプ",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 354,
              "GoodsMarkName": "９９：甘口タイプ",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 355,
              "GoodsMarkName": "９９：甘みそタイプ",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 356,
              "GoodsMarkName": "９９：本みりん（酒類表示）",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 357,
              "GoodsMarkName": "９９：指定医薬部外品",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 398,
              "GoodsMarkName": "９９：ノンアルコール",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 399,
              "GoodsMarkName": "９９：新ジャンル",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 400,
              "GoodsMarkName": "９９：スクリュ－キャップ",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 401,
              "GoodsMarkName": "９９：発泡酒",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 402,
              "GoodsMarkName": "９９：コルク",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 403,
              "GoodsMarkName": "９９：６缶",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 404,
              "GoodsMarkName": "９９：１２缶",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 405,
              "GoodsMarkName": "９９：２４缶",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 406,
              "GoodsMarkName": "９９：９缶",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 407,
              "GoodsMarkName": "９９：４缶",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 411,
              "GoodsMarkName": "９９：辛口赤ワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 412,
              "GoodsMarkName": "９９：やや辛口赤ワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 413,
              "GoodsMarkName": "９９：普通赤ワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 414,
              "GoodsMarkName": "９９：やや甘赤ワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 415,
              "GoodsMarkName": "９９：甘口赤ワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 416,
              "GoodsMarkName": "９９：辛口ロゼワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 417,
              "GoodsMarkName": "９９：やや辛ロゼワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 418,
              "GoodsMarkName": "９９：普通ロゼワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 419,
              "GoodsMarkName": "９９：やや甘ロゼワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 420,
              "GoodsMarkName": "９９：甘口ロゼワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 421,
              "GoodsMarkName": "９９：辛口白ワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 422,
              "GoodsMarkName": "９９：やや辛白ワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 423,
              "GoodsMarkName": "９９：普通白ワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 424,
              "GoodsMarkName": "９９：やや甘白ワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 425,
              "GoodsMarkName": "９９：甘口白ワイン",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 431,
              "GoodsMarkName": "９９：甲類",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 432,
              "GoodsMarkName": "９９：乙類",
              "GoodsMarkGroupCode": "06",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（酒）"
            },
            {
              "GoodsMarkCode": 442,
              "GoodsMarkName": "９９：６個",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 443,
              "GoodsMarkName": "９９：８個",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 444,
              "GoodsMarkName": "９９：１０個",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 445,
              "GoodsMarkName": "９９：１２個",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 446,
              "GoodsMarkName": "９９：１５個",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 447,
              "GoodsMarkName": "９９：２４個",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 451,
              "GoodsMarkName": "９９：区分１容易にかめる",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 452,
              "GoodsMarkName": "９９：区分２歯ぐきでつぶせる",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 453,
              "GoodsMarkName": "９９：区分３舌でつぶせる",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 454,
              "GoodsMarkName": "９９：区分４かまなくてよい",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 455,
              "GoodsMarkName": "９９：とろみ調整",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 501,
              "GoodsMarkName": "９９：ストレート果汁",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 502,
              "GoodsMarkName": "９９：濃縮還元",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 511,
              "GoodsMarkName": "９９：軟水",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 512,
              "GoodsMarkName": "９９：硬水",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 521,
              "GoodsMarkName": "９９：LLパン",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 530,
              "GoodsMarkName": "９９：６本",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 531,
              "GoodsMarkName": "９９：３本",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 532,
              "GoodsMarkName": "９９：４本",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 533,
              "GoodsMarkName": "９９：５本",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 534,
              "GoodsMarkName": "９９：4点注文で箱お届け",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 535,
              "GoodsMarkName": "９９：6点注文で箱お届け",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 536,
              "GoodsMarkName": "９９：8点注文で箱お届け",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 537,
              "GoodsMarkName": "９９：12点注文で箱お届け",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 538,
              "GoodsMarkName": "９９：24点注文で箱お届け",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 544,
              "GoodsMarkName": "０１：箱でお届け",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 550,
              "GoodsMarkName": "９９：レギュラー・細挽き",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 551,
              "GoodsMarkName": "９９：インスタント",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 552,
              "GoodsMarkName": "９９：レギュラー豆",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 553,
              "GoodsMarkName": "９９：レギュラー粉",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 554,
              "GoodsMarkName": "９９：レギュラー・中細挽き",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 555,
              "GoodsMarkName": "９９：レギュラー・中挽き",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 556,
              "GoodsMarkName": "９９：レギュラー・荒挽き",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 557,
              "GoodsMarkName": "９９：ノンカフェイン",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 558,
              "GoodsMarkName": "９９：カフェインレス",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 559,
              "GoodsMarkName": "９９：大容量（住関連）",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 560,
              "GoodsMarkName": "９９：コスメ_パフ付",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 561,
              "GoodsMarkName": "９９：コスメ_スポンジ付",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 562,
              "GoodsMarkName": "９９：コスメ_ブラシ付",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 563,
              "GoodsMarkName": "９９：コスメ_筆付",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 564,
              "GoodsMarkName": "９９：コスメ_パウダータイプ",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 565,
              "GoodsMarkName": "９９：コスメ_水あり・水なし両用",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 566,
              "GoodsMarkName": "９９：コスメ_リキッドタイプ",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 567,
              "GoodsMarkName": "９９：コスメ_クリームタイプ",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 568,
              "GoodsMarkName": "９９：コスメ_ふき取りタイプ",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 569,
              "GoodsMarkName": "９９：コスメ_洗い流しタイプ",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 570,
              "GoodsMarkName": "９９：コスメ_さっぱり",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 571,
              "GoodsMarkName": "９９：コスメ_しっとり",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 572,
              "GoodsMarkName": "９９：コスメ_もっとしっとり",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 573,
              "GoodsMarkName": "９９：コスメ_スーパーハード",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 574,
              "GoodsMarkName": "９９：コスメ_ハード",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 575,
              "GoodsMarkName": "９９：コスメ_ナチュラル＆ハード",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 576,
              "GoodsMarkName": "９９：コスメ_ナチュラル",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 577,
              "GoodsMarkName": "９９：コスメ_ストレート",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 578,
              "GoodsMarkName": "９９：コスメ_ウエーブ",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 579,
              "GoodsMarkName": "９９：コスメ_朝・夜",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 580,
              "GoodsMarkName": "９９：コスメ_朝",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 581,
              "GoodsMarkName": "９９：コスメ_夜",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 582,
              "GoodsMarkName": "９９：コスメ_お子さま用",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 583,
              "GoodsMarkName": "９９：コスメ_女性用",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 584,
              "GoodsMarkName": "９９：コスメ_男性用",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 585,
              "GoodsMarkName": "９９：コスメ_ボディ用",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 590,
              "GoodsMarkName": "９９：ＳＰＦ５０　ＰＡ＋＋＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 591,
              "GoodsMarkName": "９９：ＳＰＦ５０＋　ＰＡ＋＋＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 592,
              "GoodsMarkName": "９９：ＳＰＦ３７　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 599,
              "GoodsMarkName": "９９：デイリー登録できますマーク",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 601,
              "GoodsMarkName": "９９：鉢植え",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 602,
              "GoodsMarkName": "９９：庭植え",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 603,
              "GoodsMarkName": "９９：生け花",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 604,
              "GoodsMarkName": "９９：日当たり",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 605,
              "GoodsMarkName": "９９：半日陰",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 607,
              "GoodsMarkName": "９９：寒さに弱い",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 608,
              "GoodsMarkName": "９９：コスメ_人気色",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 609,
              "GoodsMarkName": "９９：コスメ_消臭",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 610,
              "GoodsMarkName": "９９：コスメ_抗菌",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 611,
              "GoodsMarkName": "９９：コスメ_晴雨兼用",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 612,
              "GoodsMarkName": "９９：コスメ_遮光",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 613,
              "GoodsMarkName": "９９：コスメ_遮熱遮光",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 614,
              "GoodsMarkName": "９９：コスメ_UVカット",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 631,
              "GoodsMarkName": "９９：ＳＰＦ３３　ＰＡ＋＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 632,
              "GoodsMarkName": "９９：ＳＰＦ３５　ＰＡ＋＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 633,
              "GoodsMarkName": "９９：ＳＰＦ３６　ＰＡ＋＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 635,
              "GoodsMarkName": "９９：ＳＰＦ４０　ＰＡ＋＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 639,
              "GoodsMarkName": "９９：ＳＰＦ５０　ＰＡ＋＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 640,
              "GoodsMarkName": "９９：ＳＰＦ５０＋　ＰＡ＋＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 643,
              "GoodsMarkName": "９９：ＳＰＦ１０　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 649,
              "GoodsMarkName": "９９：ＳＰＦ１８　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 650,
              "GoodsMarkName": "９９：ＳＰＦ１９　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 651,
              "GoodsMarkName": "９９：ＳＰＦ２０　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 653,
              "GoodsMarkName": "９９：ＳＰＦ２２　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 654,
              "GoodsMarkName": "９９：ＳＰＦ２３　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 655,
              "GoodsMarkName": "９９：ＳＰＦ２４　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 656,
              "GoodsMarkName": "９９：ＳＰＦ２５　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 657,
              "GoodsMarkName": "９９：ＳＰＦ２６　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 658,
              "GoodsMarkName": "９９：ＳＰＦ２７　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 661,
              "GoodsMarkName": "９９：ＳＰＦ３０　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 664,
              "GoodsMarkName": "９９：ＳＰＦ３３　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 665,
              "GoodsMarkName": "９９：ＳＰＦ３５　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 667,
              "GoodsMarkName": "９９：ＳＰＦ３８　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 672,
              "GoodsMarkName": "９９：ＳＰＦ５０　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 673,
              "GoodsMarkName": "９９：ＳＰＦ５０＋　ＰＡ＋＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 675,
              "GoodsMarkName": "９９：ＳＰＦ５　ＰＡ＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 676,
              "GoodsMarkName": "９９：ＳＰＦ１０　ＰＡ＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 677,
              "GoodsMarkName": "９９：ＳＰＦ１２　ＰＡ＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 679,
              "GoodsMarkName": "９９：ＳＰＦ１５　ＰＡ＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 680,
              "GoodsMarkName": "９９：ＳＰＦ１６　ＰＡ＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 681,
              "GoodsMarkName": "９９：ＳＰＦ１７　ＰＡ＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 684,
              "GoodsMarkName": "９９：ＳＰＦ２０　ＰＡ＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 690,
              "GoodsMarkName": "９９：ＳＰＦ２６　ＰＡ＋",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 701,
              "GoodsMarkName": "９９：トレペ穴　大",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 702,
              "GoodsMarkName": "９９：トレペ穴　小",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 703,
              "GoodsMarkName": "９９：電子レンジＯＫ",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 704,
              "GoodsMarkName": "９９：オーブンＯＫ",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 705,
              "GoodsMarkName": "９９：オーブントースターＯＫ",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 706,
              "GoodsMarkName": "９９：直火ＯＫ",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 707,
              "GoodsMarkName": "９９：羽なし",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 708,
              "GoodsMarkName": "９９：羽つき",
              "GoodsMarkGroupCode": "07",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報（生活用品）"
            },
            {
              "GoodsMarkCode": 711,
              "GoodsMarkName": "９９：コアノンユニセフ募金",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 715,
              "GoodsMarkName": "９９：医薬部外品",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 716,
              "GoodsMarkName": "９９：指定医薬部外品",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 717,
              "GoodsMarkName": "９９：無香性",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 718,
              "GoodsMarkName": "９９：無香料",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 719,
              "GoodsMarkName": "９９：無着色",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 720,
              "GoodsMarkName": "９９：紫外線吸収剤配合",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 721,
              "GoodsMarkName": "９９：紫外線吸収剤無配合",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 722,
              "GoodsMarkName": "９９：香料入り",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 723,
              "GoodsMarkName": "９９：微香性",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 724,
              "GoodsMarkName": "９９：パラベン（防腐剤）無配合",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 725,
              "GoodsMarkName": "９９：タール系色素無配合",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 726,
              "GoodsMarkName": "９９：女性用",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 727,
              "GoodsMarkName": "９９：男性用",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 728,
              "GoodsMarkName": "９９：男女兼用",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 730,
              "GoodsMarkName": "９９：ボディ用",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 731,
              "GoodsMarkName": "９９：標準色",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 737,
              "GoodsMarkName": "９９：染毛剤ではありません",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 750,
              "GoodsMarkName": "９９：一人で歩ける方",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 751,
              "GoodsMarkName": "９９：介助があれば歩ける方",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 752,
              "GoodsMarkName": "９９：介助があれば立てる方",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 753,
              "GoodsMarkName": "９９：介助があれば座れる方",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 754,
              "GoodsMarkName": "９９：寝て過ごす時間が長い方",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 760,
              "GoodsMarkName": "９９：がんばろう青森",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 761,
              "GoodsMarkName": "９９：がんばろう岩手",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 762,
              "GoodsMarkName": "９９：がんばろう宮城",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 763,
              "GoodsMarkName": "９９：がんばろう福島",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 764,
              "GoodsMarkName": "９９：がんばろう茨城",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 765,
              "GoodsMarkName": "９９：がんばろう栃木",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 766,
              "GoodsMarkName": "９９：がんばろう群馬",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 767,
              "GoodsMarkName": "９９：がんばろう埼玉",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 768,
              "GoodsMarkName": "９９：がんばろう千葉",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 769,
              "GoodsMarkName": "９９：がんばろう長野",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 806,
              "GoodsMarkName": "９９：（ク）ｍａｄｅ　ｉｎにいがた（商品マスタ）",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 811,
              "GoodsMarkName": "９９：いばらきオリジナル",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 813,
              "GoodsMarkName": "９９：茨県内製造",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 815,
              "GoodsMarkName": "９９：茨県内原料製造",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 823,
              "GoodsMarkName": "９９：栃県内製造",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 824,
              "GoodsMarkName": "９９：栃県内原料",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 825,
              "GoodsMarkName": "９９：栃県内原料製造",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 831,
              "GoodsMarkName": "９９：たべようぐんま",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 835,
              "GoodsMarkName": "９９：群県内製造",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 836,
              "GoodsMarkName": "９９：群県内原料",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 842,
              "GoodsMarkName": "９９：千県内製造",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 844,
              "GoodsMarkName": "９９：千県内製造原料",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 852,
              "GoodsMarkName": "９９：埼県内製造",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 854,
              "GoodsMarkName": "９９：埼県内原料製造",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 871,
              "GoodsMarkName": "９９：ながの開発商品",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 873,
              "GoodsMarkName": "９９：長県内製造",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 875,
              "GoodsMarkName": "９９：長県内原料製造",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 882,
              "GoodsMarkName": "９９：新県内製造",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 884,
              "GoodsMarkName": "９９：新県内原料製造",
              "GoodsMarkGroupCode": "08",
              "GoodsMark": "0",
              "GoodsMarkCaption": "地域ページ"
            },
            {
              "GoodsMarkCode": 894,
              "GoodsMarkName": "９９：ＣＫ　にいがた大好き！（商品マスタ）",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 895,
              "GoodsMarkName": "９９：ＣＫ　にいがた１００（商品マスタ）",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 896,
              "GoodsMarkName": "９９：ＣＫ　にいがたｍａｄｅ　ｉｎ　にいがた（商品",
              "GoodsMarkGroupCode": "05",
              "GoodsMark": "0",
              "GoodsMarkCaption": "商品情報"
            },
            {
              "GoodsMarkCode": 916,
              "GoodsMarkName": "９９：ＳＰＦ１２",
              "GoodsMarkGroupCode": "02",
              "GoodsMark": "0",
              "GoodsMarkCaption": "促進マーク"
            },
            {
              "GoodsMarkCode": 973,
              "GoodsMarkName": "９９：消費税８％",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            },
            {
              "GoodsMarkCode": 974,
              "GoodsMarkName": "９９：消費税１０％",
              "GoodsMarkGroupCode": "11",
              "GoodsMark": "0",
              "GoodsMarkCaption": "供給（予備）"
            }
          ]
        },
        "PCodeTextInfo": {
          "TextInfoList": [
            {
              "TextKindID": "001",
              "TextKindNum": "2",
              "StringValue": "北海道産のスルメイカ、ミズダコ、メカブを混合した海鮮丼。"
            },
            {
              "TextKindID": "004",
              "TextKindNum": "1",
              "StringValue": "手軽に北海道の海の幸をどうぞ"
            },
            {
              "TextKindID": "019",
              "TextKindNum": "1",
              "StringValue": ""
            },
            {
              "TextKindID": "008",
              "TextKindNum": "1",
              "StringValue": ""
            },
            {
              "TextKindID": "023",
              "TextKindNum": "1",
              "StringValue": ""
            },
            {
              "TextKindID": "022",
              "TextKindNum": "1",
              "StringValue": ""
            },
            {
              "TextKindID": "038",
              "TextKindNum": "1",
              "StringValue": "吸水量"
            },
            {
              "TextKindID": "040",
              "TextKindNum": "1",
              "StringValue": "調理時間の目安"
            },
          ],
          "BuyerComment": ""
        },
        "PCodeOrderPD": {
          "StinkGoodsDiv": "0",
          "CaseSupplyDiv": "0",
          "LongKeepDiv": "0",
          "ArrivalAreaDiv": "00",
          "ArrivalGoodsTemp": -10,
          "ArrivalAdminDays": 2,
          "DutiesFormDailyDiv": "00",
          "DutiesFormSpotDiv": "0"
        },
        "PCodePublishVoice": {
          "CoopPublishVoiceList": [
            {
              "CoopCode": "142",
              "PlanCoopName": "いばらき",
              "ReceiptNum": "",
              "CorrectInquiryContents": ""
            },
            {
              "CoopCode": "163",
              "PlanCoopName": "とちぎ",
              "ReceiptNum": "",
              "CorrectInquiryContents": ""
            },
            {
              "CoopCode": "185",
              "PlanCoopName": "ぐんま",
              "ReceiptNum": "",
              "CorrectInquiryContents": ""
            },
            {
              "CoopCode": "240",
              "PlanCoopName": "ちば",
              "ReceiptNum": "",
              "CorrectInquiryContents": ""
            },
            {
              "CoopCode": "210",
              "PlanCoopName": "さいたま",
              "ReceiptNum": "",
              "CorrectInquiryContents": ""
            },
            {
              "CoopCode": "302",
              "PlanCoopName": "とうきょう",
              "ReceiptNum": "",
              "CorrectInquiryContents": ""
            },
            {
              "CoopCode": "515",
              "PlanCoopName": "ながの",
              "ReceiptNum": "",
              "CorrectInquiryContents": ""
            },
            {
              "CoopCode": "451",
              "PlanCoopName": "にいがた",
              "ReceiptNum": "",
              "CorrectInquiryContents": ""
            }
          ]
        },
        "PCodePlanNum": {
          "PlanNumAiPredictionTotal": 800,
          "PlanNumTotal": 8000,
          "CoopPlanNumList": [
            {
              "CoopCode": "142",
              "PlanCoopName": "いばらき",
              "PlanNumAiPrediction": 100,
              "PlanNum": 718,
              "LimitNumTotal": 0,
              "LimitNumPerson": 0,
              "DeliveryLeadTimeType": "01",
              "DelivCatalogID": "20231004"
            },
            {
              "CoopCode": "163",
              "PlanCoopName": "とちぎ",
              "PlanNumAiPrediction": 100,
              "PlanNum": 507,
              "LimitNumTotal": 0,
              "LimitNumPerson": 0,
              "DeliveryLeadTimeType": "01",
              "DelivCatalogID": "20231004"
            },
            {
              "CoopCode": "185",
              "PlanCoopName": "ぐんま",
              "PlanNumAiPrediction": 100,
              "PlanNum": 544,
              "LimitNumTotal": 0,
              "LimitNumPerson": 0,
              "DeliveryLeadTimeType": "01",
              "DelivCatalogID": "20231004"
            },
            {
              "CoopCode": "240",
              "PlanCoopName": "ちば",
              "PlanNumAiPrediction": 100,
              "PlanNum": 1683,
              "LimitNumTotal": 0,
              "LimitNumPerson": 0,
              "DeliveryLeadTimeType": "01",
              "DelivCatalogID": "20231004"
            },
            {
              "CoopCode": "210",
              "PlanCoopName": "さいたま",
              "PlanNumAiPrediction": 100,
              "PlanNum": 1559,
              "LimitNumTotal": 0,
              "LimitNumPerson": 0,
              "DeliveryLeadTimeType": "01",
              "DelivCatalogID": "20231004"
            },
            {
              "CoopCode": "302",
              "PlanCoopName": "とうきょう",
              "PlanNumAiPrediction": 100,
              "PlanNum": 1916,
              "LimitNumTotal": 0,
              "LimitNumPerson": 0,
              "DeliveryLeadTimeType": "01",
              "DelivCatalogID": "20231004"
            },
            {
              "CoopCode": "515",
              "PlanCoopName": "ながの",
              "PlanNumAiPrediction": 100,
              "PlanNum": 739,
              "LimitNumTotal": 0,
              "LimitNumPerson": 0,
              "DeliveryLeadTimeType": "01",
              "DelivCatalogID": "20231004"
            },
            {
              "CoopCode": "451",
              "PlanCoopName": "にいがた",
              "PlanNumAiPrediction": 100,
              "PlanNum": 334,
              "LimitNumTotal": 0,
              "LimitNumPerson": 0,
              "DeliveryLeadTimeType": "01",
              "DelivCatalogID": "20231004"
            }
          ]
        },
        "PCodeIcon": {
          "IconList": [
            {
              "IconCode": "001",
              "IconName": "アイコン１",
              "ArrangeDiv": "下部",
              "PublishOrder": "1",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "002",
              "IconName": "アイコン２",
              "ArrangeDiv": "上部",
              "PublishOrder": "2",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "003",
              "IconName": "アイコン３",
              "ArrangeDiv": "上部",
              "PublishOrder": "3",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "004",
              "IconName": "アイコン４",
              "ArrangeDiv": "下部",
              "PublishOrder": "4",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "005",
              "IconName": "アイコン５",
              "ArrangeDiv": "下部",
              "PublishOrder": "1",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "006",
              "IconName": "アイコン６",
              "ArrangeDiv": "上部",
              "PublishOrder": "2",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "007",
              "IconName": "アイコン７",
              "ArrangeDiv": "上部",
              "PublishOrder": "3",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "008",
              "IconName": "アイコン８",
              "ArrangeDiv": "下部",
              "PublishOrder": "4",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "009",
              "IconName": "アイコン９",
              "ArrangeDiv": "下部",
              "PublishOrder": "1",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "010",
              "IconName": "アイコン１０",
              "ArrangeDiv": "上部",
              "PublishOrder": "2",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "011",
              "IconName": "アイコン１１",
              "ArrangeDiv": "上部",
              "PublishOrder": "3",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "012",
              "IconName": "アイコン１２",
              "ArrangeDiv": "下部",
              "PublishOrder": "4",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "013",
              "IconName": "アイコン１３",
              "ArrangeDiv": "下部",
              "PublishOrder": "1",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "014",
              "IconName": "アイコン１４",
              "ArrangeDiv": "上部",
              "PublishOrder": "2",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "1",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "015",
              "IconName": "アイコン１５",
              "ArrangeDiv": "上部",
              "PublishOrder": "3",
              "Icon0": "0",
              "Icon1": "0",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            },
            {
              "IconCode": "016",
              "IconName": "アイコン１６",
              "ArrangeDiv": "下部",
              "PublishOrder": "4",
              "Icon0": "0",
              "Icon1": "1",
              "Icon2": "0",
              "Icon3": "0",
              "Icon4": "0",
              "Icon5": "0",
              "Icon6": "0",
              "Icon7": "0"
            }
          ]
        },
      },
      "resultItemGridContentDataVO": {
        "AllergenList": [
          {
            "AllergenDiv": "001",
            "AllergenName": "卵",
            "PublishDiv": "1"
          },
          {
            "AllergenDiv": "002",
            "AllergenName": "乳",
            "PublishDiv": "1"
          },
          {
            "AllergenDiv": "003",
            "AllergenName": "小麦",
            "PublishDiv": "1"
          },
          {
            "AllergenDiv": "004",
            "AllergenName": "そば",
            "PublishDiv": "1"
          },
          {
            "AllergenDiv": "005",
            "AllergenName": "落花生",
            "PublishDiv": "1"
          },
          {
            "AllergenDiv": "006",
            "AllergenName": "あわび",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "007",
            "AllergenName": "いか",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "008",
            "AllergenName": "いくら",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "009",
            "AllergenName": "えび",
            "PublishDiv": "1"
          },
          {
            "AllergenDiv": "010",
            "AllergenName": "オレンジ",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "011",
            "AllergenName": "かに",
            "PublishDiv": "1"
          },
          {
            "AllergenDiv": "012",
            "AllergenName": "キウイフルーツ",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "013",
            "AllergenName": "牛肉",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "014",
            "AllergenName": "くるみ",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "015",
            "AllergenName": "さけ",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "016",
            "AllergenName": "さば",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "017",
            "AllergenName": "大豆",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "018",
            "AllergenName": "鶏肉",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "019",
            "AllergenName": "豚肉",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "020",
            "AllergenName": "まつたけ",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "021",
            "AllergenName": "もも",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "022",
            "AllergenName": "やまいも",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "023",
            "AllergenName": "りんご",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "024",
            "AllergenName": "ゼラチン",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "025",
            "AllergenName": "米",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "026",
            "AllergenName": "魚介類",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "027",
            "AllergenName": "ごま",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "028",
            "AllergenName": "バナナ",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "029",
            "AllergenName": "カシューナッツ",
            "PublishDiv": "0"
          },
          {
            "AllergenDiv": "030",
            "AllergenName": "アーモンド",
            "PublishDiv": "0"
          }
        ],
        "CoopList": [
          {
            "CoopCode": "142",
            "CoopShortName": "い"
          },
          {
            "CoopCode": "163",
            "CoopShortName": "と"
          },
          {
            "CoopCode": "185",
            "CoopShortName": "ぐ"
          },
          {
            "CoopCode": "240",
            "CoopShortName": "ち"
          },
          {
            "CoopCode": "210",
            "CoopShortName": "さ"
          },
          {
            "CoopCode": "302",
            "CoopShortName": "とう"
          },
          {
            "CoopCode": "515",
            "CoopShortName": "な"
          },
          {
            "CoopCode": "451",
            "CoopShortName": "に"
          },
          {
            "CoopCode": "454",
            "CoopShortName": "ク"
          }
        ],
        "PromoteMarkList": [
          {
            "PromoteMarkCode": 6,
            "PromoteMarkName": "０１：今週のお買得",
            "PromoteMarkGroupName": "特別価格",
            "PromoteMarkGroupCodeName": "01:特別価格",
            "PromoteMarkGroupCode": "01"
          },
          {
            "PromoteMarkCode": 6,
            "PromoteMarkName": "０１：今週のお買得",
            "PromoteMarkGroupName": "特別価格",
            "PromoteMarkGroupCodeName": "01:特別価格",
            "PromoteMarkGroupCode": "01"
          },
          {
            "PromoteMarkCode": 6,
            "PromoteMarkName": "０１：今週のお買得",
            "PromoteMarkGroupName": "特別価格",
            "PromoteMarkGroupCodeName": "01:特別価格",
            "PromoteMarkGroupCode": "01"
          },
          {
            "PromoteMarkCode": 6,
            "PromoteMarkName": "０１：今週のお買得",
            "PromoteMarkGroupName": "特別価格",
            "PromoteMarkGroupCodeName": "01:特別価格",
            "PromoteMarkGroupCode": "01"
          },
          {
            "PromoteMarkCode": 6,
            "PromoteMarkName": "０１：今週のお買得",
            "PromoteMarkGroupName": "特別価格",
            "PromoteMarkGroupCodeName": "01:特別価格",
            "PromoteMarkGroupCode": "01"
          },
          {
            "PromoteMarkCode": 6,
            "PromoteMarkName": "０１：今週のお買得",
            "PromoteMarkGroupName": "特別価格",
            "PromoteMarkGroupCodeName": "01:特別価格",
            "PromoteMarkGroupCode": "01"
          },
          {
            "PromoteMarkCode": 6,
            "PromoteMarkName": "０１：今週のお買得",
            "PromoteMarkGroupName": "特別価格",
            "PromoteMarkGroupCodeName": "01:特別価格",
            "PromoteMarkGroupCode": "01"
          },
          {
            "PromoteMarkCode": 6,
            "PromoteMarkName": "０１：今週のお買得",
            "PromoteMarkGroupName": "特別価格",
            "PromoteMarkGroupCodeName": "01:特別価格",
            "PromoteMarkGroupCode": "01"
          },
          {
            "PromoteMarkCode": 6,
            "PromoteMarkName": "０１：今週のお買得",
            "PromoteMarkGroupName": "特別価格",
            "PromoteMarkGroupCodeName": "01:特別価格",
            "PromoteMarkGroupCode": "01"
          },
          {
            "PromoteMarkCode": 12,
            "PromoteMarkName": "０１：くらし応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 12,
            "PromoteMarkName": "０１：くらし応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 12,
            "PromoteMarkName": "０１：くらし応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 12,
            "PromoteMarkName": "０１：くらし応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 12,
            "PromoteMarkName": "０１：くらし応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 12,
            "PromoteMarkName": "０１：くらし応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 12,
            "PromoteMarkName": "０１：くらし応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 12,
            "PromoteMarkName": "０１：くらし応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 12,
            "PromoteMarkName": "０１：くらし応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 13,
            "PromoteMarkName": "０１：くらし応援 さらにお得",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 13,
            "PromoteMarkName": "０１：くらし応援 さらにお得",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 13,
            "PromoteMarkName": "０１：くらし応援 さらにお得",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 13,
            "PromoteMarkName": "０１：くらし応援 さらにお得",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 13,
            "PromoteMarkName": "０１：くらし応援 さらにお得",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 13,
            "PromoteMarkName": "０１：くらし応援 さらにお得",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 13,
            "PromoteMarkName": "０１：くらし応援 さらにお得",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 13,
            "PromoteMarkName": "０１：くらし応援 さらにお得",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 13,
            "PromoteMarkName": "０１：くらし応援 さらにお得",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 14,
            "PromoteMarkName": "０１：週次テーマ１",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 14,
            "PromoteMarkName": "０１：週次テーマ１",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 14,
            "PromoteMarkName": "０１：週次テーマ１",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 14,
            "PromoteMarkName": "０１：週次テーマ１",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 14,
            "PromoteMarkName": "０１：週次テーマ１",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 14,
            "PromoteMarkName": "０１：週次テーマ１",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 14,
            "PromoteMarkName": "０１：週次テーマ１",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 14,
            "PromoteMarkName": "０１：週次テーマ１",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 14,
            "PromoteMarkName": "０１：週次テーマ１",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 15,
            "PromoteMarkName": "０１：週次テーマ２",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 15,
            "PromoteMarkName": "０１：週次テーマ２",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 15,
            "PromoteMarkName": "０１：週次テーマ２",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 15,
            "PromoteMarkName": "０１：週次テーマ２",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 15,
            "PromoteMarkName": "０１：週次テーマ２",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 15,
            "PromoteMarkName": "０１：週次テーマ２",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 15,
            "PromoteMarkName": "０１：週次テーマ２",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 15,
            "PromoteMarkName": "０１：週次テーマ２",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 15,
            "PromoteMarkName": "０１：週次テーマ２",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 16,
            "PromoteMarkName": "０１：包材変更可能性あり",
            "PromoteMarkGroupName": "商品情報",
            "PromoteMarkGroupCodeName": "05:商品情報",
            "PromoteMarkGroupCode": "05"
          },
          {
            "PromoteMarkCode": 16,
            "PromoteMarkName": "０１：包材変更可能性あり",
            "PromoteMarkGroupName": "商品情報",
            "PromoteMarkGroupCodeName": "05:商品情報",
            "PromoteMarkGroupCode": "05"
          },
          {
            "PromoteMarkCode": 16,
            "PromoteMarkName": "０１：包材変更可能性あり",
            "PromoteMarkGroupName": "商品情報",
            "PromoteMarkGroupCodeName": "05:商品情報",
            "PromoteMarkGroupCode": "05"
          },
          {
            "PromoteMarkCode": 16,
            "PromoteMarkName": "０１：包材変更可能性あり",
            "PromoteMarkGroupName": "商品情報",
            "PromoteMarkGroupCodeName": "05:商品情報",
            "PromoteMarkGroupCode": "05"
          },
          {
            "PromoteMarkCode": 16,
            "PromoteMarkName": "０１：包材変更可能性あり",
            "PromoteMarkGroupName": "商品情報",
            "PromoteMarkGroupCodeName": "05:商品情報",
            "PromoteMarkGroupCode": "05"
          },
          {
            "PromoteMarkCode": 16,
            "PromoteMarkName": "０１：包材変更可能性あり",
            "PromoteMarkGroupName": "商品情報",
            "PromoteMarkGroupCodeName": "05:商品情報",
            "PromoteMarkGroupCode": "05"
          },
          {
            "PromoteMarkCode": 16,
            "PromoteMarkName": "０１：包材変更可能性あり",
            "PromoteMarkGroupName": "商品情報",
            "PromoteMarkGroupCodeName": "05:商品情報",
            "PromoteMarkGroupCode": "05"
          },
          {
            "PromoteMarkCode": 16,
            "PromoteMarkName": "０１：包材変更可能性あり",
            "PromoteMarkGroupName": "商品情報",
            "PromoteMarkGroupCodeName": "05:商品情報",
            "PromoteMarkGroupCode": "05"
          },
          {
            "PromoteMarkCode": 16,
            "PromoteMarkName": "０１：包材変更可能性あり",
            "PromoteMarkGroupName": "商品情報",
            "PromoteMarkGroupCodeName": "05:商品情報",
            "PromoteMarkGroupCode": "05"
          },
          {
            "PromoteMarkCode": 17,
            "PromoteMarkName": "０１：おかずのヒント",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 17,
            "PromoteMarkName": "０１：おかずのヒント",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 17,
            "PromoteMarkName": "０１：おかずのヒント",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 17,
            "PromoteMarkName": "０１：おかずのヒント",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 17,
            "PromoteMarkName": "０１：おかずのヒント",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 17,
            "PromoteMarkName": "０１：おかずのヒント",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 17,
            "PromoteMarkName": "０１：おかずのヒント",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 17,
            "PromoteMarkName": "０１：おかずのヒント",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 17,
            "PromoteMarkName": "０１：おかずのヒント",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 18,
            "PromoteMarkName": "０１：訴求チラシ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 18,
            "PromoteMarkName": "０１：訴求チラシ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 18,
            "PromoteMarkName": "０１：訴求チラシ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 18,
            "PromoteMarkName": "０１：訴求チラシ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 18,
            "PromoteMarkName": "０１：訴求チラシ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 18,
            "PromoteMarkName": "０１：訴求チラシ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 18,
            "PromoteMarkName": "０１：訴求チラシ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 18,
            "PromoteMarkName": "０１：訴求チラシ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 18,
            "PromoteMarkName": "０１：訴求チラシ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 22,
            "PromoteMarkName": "０２：旬",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 22,
            "PromoteMarkName": "０２：旬",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 22,
            "PromoteMarkName": "０２：旬",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 22,
            "PromoteMarkName": "０２：旬",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 22,
            "PromoteMarkName": "０２：旬",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 22,
            "PromoteMarkName": "０２：旬",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 22,
            "PromoteMarkName": "０２：旬",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 22,
            "PromoteMarkName": "０２：旬",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 22,
            "PromoteMarkName": "０２：旬",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 25,
            "PromoteMarkName": "０１：特集ページ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 25,
            "PromoteMarkName": "０１：特集ページ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 25,
            "PromoteMarkName": "０１：特集ページ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 25,
            "PromoteMarkName": "０１：特集ページ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 25,
            "PromoteMarkName": "０１：特集ページ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 25,
            "PromoteMarkName": "０１：特集ページ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 25,
            "PromoteMarkName": "０１：特集ページ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 25,
            "PromoteMarkName": "０１：特集ページ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 25,
            "PromoteMarkName": "０１：特集ページ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 31,
            "PromoteMarkName": "９９：県内産",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 31,
            "PromoteMarkName": "９９：県内産",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 31,
            "PromoteMarkName": "９９：県内産",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 31,
            "PromoteMarkName": "９９：県内産",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 31,
            "PromoteMarkName": "９９：県内産",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 31,
            "PromoteMarkName": "９９：県内産",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 31,
            "PromoteMarkName": "９９：県内産",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 31,
            "PromoteMarkName": "９９：県内産",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 31,
            "PromoteMarkName": "９９：県内産",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 33,
            "PromoteMarkName": "０１：数量限定",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 33,
            "PromoteMarkName": "０１：数量限定",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 33,
            "PromoteMarkName": "０１：数量限定",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 33,
            "PromoteMarkName": "０１：数量限定",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 33,
            "PromoteMarkName": "０１：数量限定",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 33,
            "PromoteMarkName": "０１：数量限定",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 33,
            "PromoteMarkName": "０１：数量限定",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 33,
            "PromoteMarkName": "０１：数量限定",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 33,
            "PromoteMarkName": "０１：数量限定",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 48,
            "PromoteMarkName": "０２：忘れず注文",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 48,
            "PromoteMarkName": "０２：忘れず注文",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 48,
            "PromoteMarkName": "０２：忘れず注文",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 48,
            "PromoteMarkName": "０２：忘れず注文",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 48,
            "PromoteMarkName": "０２：忘れず注文",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 48,
            "PromoteMarkName": "０２：忘れず注文",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 48,
            "PromoteMarkName": "０２：忘れず注文",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 48,
            "PromoteMarkName": "０２：忘れず注文",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 48,
            "PromoteMarkName": "０２：忘れず注文",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 50,
            "PromoteMarkName": "０１：最安値",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 50,
            "PromoteMarkName": "０１：最安値",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 50,
            "PromoteMarkName": "０１：最安値",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 50,
            "PromoteMarkName": "０１：最安値",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 50,
            "PromoteMarkName": "０１：最安値",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 50,
            "PromoteMarkName": "０１：最安値",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 50,
            "PromoteMarkName": "０１：最安値",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 50,
            "PromoteMarkName": "０１：最安値",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 50,
            "PromoteMarkName": "０１：最安値",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 53,
            "PromoteMarkName": "０１：おためし価格",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 53,
            "PromoteMarkName": "０１：おためし価格",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 53,
            "PromoteMarkName": "０１：おためし価格",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 53,
            "PromoteMarkName": "０１：おためし価格",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 53,
            "PromoteMarkName": "０１：おためし価格",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 53,
            "PromoteMarkName": "０１：おためし価格",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 53,
            "PromoteMarkName": "０１：おためし価格",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 53,
            "PromoteMarkName": "０１：おためし価格",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 53,
            "PromoteMarkName": "０１：おためし価格",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 54,
            "PromoteMarkName": "０２：予約",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 54,
            "PromoteMarkName": "０２：予約",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 54,
            "PromoteMarkName": "０２：予約",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 54,
            "PromoteMarkName": "０２：予約",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 54,
            "PromoteMarkName": "０２：予約",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 54,
            "PromoteMarkName": "０２：予約",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 54,
            "PromoteMarkName": "０２：予約",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 54,
            "PromoteMarkName": "０２：予約",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 54,
            "PromoteMarkName": "０２：予約",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 58,
            "PromoteMarkName": "０１：今回より値下げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 58,
            "PromoteMarkName": "０１：今回より値下げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 58,
            "PromoteMarkName": "０１：今回より値下げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 58,
            "PromoteMarkName": "０１：今回より値下げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 58,
            "PromoteMarkName": "０１：今回より値下げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 58,
            "PromoteMarkName": "０１：今回より値下げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 58,
            "PromoteMarkName": "０１：今回より値下げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 58,
            "PromoteMarkName": "０１：今回より値下げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 58,
            "PromoteMarkName": "０１：今回より値下げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 59,
            "PromoteMarkName": "０１：今回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 59,
            "PromoteMarkName": "０１：今回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 59,
            "PromoteMarkName": "０１：今回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 59,
            "PromoteMarkName": "０１：今回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 59,
            "PromoteMarkName": "０１：今回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 59,
            "PromoteMarkName": "０１：今回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 59,
            "PromoteMarkName": "０１：今回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 59,
            "PromoteMarkName": "０１：今回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 59,
            "PromoteMarkName": "０１：今回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 60,
            "PromoteMarkName": "０１：次回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 60,
            "PromoteMarkName": "０１：次回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 60,
            "PromoteMarkName": "０１：次回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 60,
            "PromoteMarkName": "０１：次回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 60,
            "PromoteMarkName": "０１：次回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 60,
            "PromoteMarkName": "０１：次回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 60,
            "PromoteMarkName": "０１：次回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 60,
            "PromoteMarkName": "０１：次回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 60,
            "PromoteMarkName": "０１：次回より値上げ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 61,
            "PromoteMarkName": "０１：今回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 61,
            "PromoteMarkName": "０１：今回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 61,
            "PromoteMarkName": "０１：今回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 61,
            "PromoteMarkName": "０１：今回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 61,
            "PromoteMarkName": "０１：今回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 61,
            "PromoteMarkName": "０１：今回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 61,
            "PromoteMarkName": "０１：今回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 61,
            "PromoteMarkName": "０１：今回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 61,
            "PromoteMarkName": "０１：今回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 62,
            "PromoteMarkName": "０１：次回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 62,
            "PromoteMarkName": "０１：次回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 62,
            "PromoteMarkName": "０１：次回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 62,
            "PromoteMarkName": "０１：次回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 62,
            "PromoteMarkName": "０１：次回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 62,
            "PromoteMarkName": "０１：次回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 62,
            "PromoteMarkName": "０１：次回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 62,
            "PromoteMarkName": "０１：次回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 62,
            "PromoteMarkName": "０１：次回より減量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 63,
            "PromoteMarkName": "０１：今回より増量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 63,
            "PromoteMarkName": "０１：今回より増量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 63,
            "PromoteMarkName": "０１：今回より増量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 63,
            "PromoteMarkName": "０１：今回より増量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 63,
            "PromoteMarkName": "０１：今回より増量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 63,
            "PromoteMarkName": "０１：今回より増量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 63,
            "PromoteMarkName": "０１：今回より増量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 63,
            "PromoteMarkName": "０１：今回より増量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 63,
            "PromoteMarkName": "０１：今回より増量",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 69,
            "PromoteMarkName": "０１：ポイント利用",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 69,
            "PromoteMarkName": "０１：ポイント利用",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 69,
            "PromoteMarkName": "０１：ポイント利用",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 69,
            "PromoteMarkName": "０１：ポイント利用",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 69,
            "PromoteMarkName": "０１：ポイント利用",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 69,
            "PromoteMarkName": "０１：ポイント利用",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 69,
            "PromoteMarkName": "０１：ポイント利用",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 69,
            "PromoteMarkName": "０１：ポイント利用",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 69,
            "PromoteMarkName": "０１：ポイント利用",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 70,
            "PromoteMarkName": "０１：特集２～３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 70,
            "PromoteMarkName": "０１：特集２～３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 70,
            "PromoteMarkName": "０１：特集２～３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 70,
            "PromoteMarkName": "０１：特集２～３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 70,
            "PromoteMarkName": "０１：特集２～３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 70,
            "PromoteMarkName": "０１：特集２～３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 70,
            "PromoteMarkName": "０１：特集２～３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 70,
            "PromoteMarkName": "０１：特集２～３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 70,
            "PromoteMarkName": "０１：特集２～３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 71,
            "PromoteMarkName": "０１：特集４～５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 71,
            "PromoteMarkName": "０１：特集４～５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 71,
            "PromoteMarkName": "０１：特集４～５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 71,
            "PromoteMarkName": "０１：特集４～５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 71,
            "PromoteMarkName": "０１：特集４～５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 71,
            "PromoteMarkName": "０１：特集４～５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 71,
            "PromoteMarkName": "０１：特集４～５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 71,
            "PromoteMarkName": "０１：特集４～５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 71,
            "PromoteMarkName": "０１：特集４～５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 72,
            "PromoteMarkName": "０１：特集６～７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 72,
            "PromoteMarkName": "０１：特集６～７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 72,
            "PromoteMarkName": "０１：特集６～７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 72,
            "PromoteMarkName": "０１：特集６～７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 72,
            "PromoteMarkName": "０１：特集６～７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 72,
            "PromoteMarkName": "０１：特集６～７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 72,
            "PromoteMarkName": "０１：特集６～７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 72,
            "PromoteMarkName": "０１：特集６～７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 72,
            "PromoteMarkName": "０１：特集６～７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 73,
            "PromoteMarkName": "０１：特集８～９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 73,
            "PromoteMarkName": "０１：特集８～９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 73,
            "PromoteMarkName": "０１：特集８～９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 73,
            "PromoteMarkName": "０１：特集８～９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 73,
            "PromoteMarkName": "０１：特集８～９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 73,
            "PromoteMarkName": "０１：特集８～９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 73,
            "PromoteMarkName": "０１：特集８～９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 73,
            "PromoteMarkName": "０１：特集８～９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 73,
            "PromoteMarkName": "０１：特集８～９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 74,
            "PromoteMarkName": "０１：特集１０～１１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 74,
            "PromoteMarkName": "０１：特集１０～１１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 74,
            "PromoteMarkName": "０１：特集１０～１１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 74,
            "PromoteMarkName": "０１：特集１０～１１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 74,
            "PromoteMarkName": "０１：特集１０～１１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 74,
            "PromoteMarkName": "０１：特集１０～１１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 74,
            "PromoteMarkName": "０１：特集１０～１１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 74,
            "PromoteMarkName": "０１：特集１０～１１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 74,
            "PromoteMarkName": "０１：特集１０～１１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 75,
            "PromoteMarkName": "０１：特集１２～１３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 75,
            "PromoteMarkName": "０１：特集１２～１３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 75,
            "PromoteMarkName": "０１：特集１２～１３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 75,
            "PromoteMarkName": "０１：特集１２～１３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 75,
            "PromoteMarkName": "０１：特集１２～１３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 75,
            "PromoteMarkName": "０１：特集１２～１３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 75,
            "PromoteMarkName": "０１：特集１２～１３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 75,
            "PromoteMarkName": "０１：特集１２～１３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 75,
            "PromoteMarkName": "０１：特集１２～１３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 76,
            "PromoteMarkName": "０１：特集１４～１５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 76,
            "PromoteMarkName": "０１：特集１４～１５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 76,
            "PromoteMarkName": "０１：特集１４～１５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 76,
            "PromoteMarkName": "０１：特集１４～１５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 76,
            "PromoteMarkName": "０１：特集１４～１５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 76,
            "PromoteMarkName": "０１：特集１４～１５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 76,
            "PromoteMarkName": "０１：特集１４～１５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 76,
            "PromoteMarkName": "０１：特集１４～１５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 76,
            "PromoteMarkName": "０１：特集１４～１５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 77,
            "PromoteMarkName": "０１：特集１６～１７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 77,
            "PromoteMarkName": "０１：特集１６～１７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 77,
            "PromoteMarkName": "０１：特集１６～１７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 77,
            "PromoteMarkName": "０１：特集１６～１７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 77,
            "PromoteMarkName": "０１：特集１６～１７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 77,
            "PromoteMarkName": "０１：特集１６～１７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 77,
            "PromoteMarkName": "０１：特集１６～１７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 77,
            "PromoteMarkName": "０１：特集１６～１７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 77,
            "PromoteMarkName": "０１：特集１６～１７頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 78,
            "PromoteMarkName": "０１：特集１８～１９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 78,
            "PromoteMarkName": "０１：特集１８～１９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 78,
            "PromoteMarkName": "０１：特集１８～１９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 78,
            "PromoteMarkName": "０１：特集１８～１９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 78,
            "PromoteMarkName": "０１：特集１８～１９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 78,
            "PromoteMarkName": "０１：特集１８～１９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 78,
            "PromoteMarkName": "０１：特集１８～１９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 78,
            "PromoteMarkName": "０１：特集１８～１９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 78,
            "PromoteMarkName": "０１：特集１８～１９頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 79,
            "PromoteMarkName": "０１：特集２０～２１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 79,
            "PromoteMarkName": "０１：特集２０～２１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 79,
            "PromoteMarkName": "０１：特集２０～２１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 79,
            "PromoteMarkName": "０１：特集２０～２１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 79,
            "PromoteMarkName": "０１：特集２０～２１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 79,
            "PromoteMarkName": "０１：特集２０～２１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 79,
            "PromoteMarkName": "０１：特集２０～２１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 79,
            "PromoteMarkName": "０１：特集２０～２１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 79,
            "PromoteMarkName": "０１：特集２０～２１頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 80,
            "PromoteMarkName": "０１：特集　美容健康",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 80,
            "PromoteMarkName": "０１：特集　美容健康",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 80,
            "PromoteMarkName": "０１：特集　美容健康",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 80,
            "PromoteMarkName": "０１：特集　美容健康",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 80,
            "PromoteMarkName": "０１：特集　美容健康",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 80,
            "PromoteMarkName": "０１：特集　美容健康",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 80,
            "PromoteMarkName": "０１：特集　美容健康",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 80,
            "PromoteMarkName": "０１：特集　美容健康",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 80,
            "PromoteMarkName": "０１：特集　美容健康",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 81,
            "PromoteMarkName": "０１：特集　ラクデリ（とうきょうのみ）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 81,
            "PromoteMarkName": "０１：特集　ラクデリ（とうきょうのみ）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 81,
            "PromoteMarkName": "０１：特集　ラクデリ（とうきょうのみ）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 81,
            "PromoteMarkName": "０１：特集　ラクデリ（とうきょうのみ）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 81,
            "PromoteMarkName": "０１：特集　ラクデリ（とうきょうのみ）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 81,
            "PromoteMarkName": "０１：特集　ラクデリ（とうきょうのみ）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 81,
            "PromoteMarkName": "０１：特集　ラクデリ（とうきょうのみ）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 81,
            "PromoteMarkName": "０１：特集　ラクデリ（とうきょうのみ）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 81,
            "PromoteMarkName": "０１：特集　ラクデリ（とうきょうのみ）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 84,
            "PromoteMarkName": "０１：特集　朝食応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 84,
            "PromoteMarkName": "０１：特集　朝食応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 84,
            "PromoteMarkName": "０１：特集　朝食応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 84,
            "PromoteMarkName": "０１：特集　朝食応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 84,
            "PromoteMarkName": "０１：特集　朝食応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 84,
            "PromoteMarkName": "０１：特集　朝食応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 84,
            "PromoteMarkName": "０１：特集　朝食応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 84,
            "PromoteMarkName": "０１：特集　朝食応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 84,
            "PromoteMarkName": "０１：特集　朝食応援",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 87,
            "PromoteMarkName": "０１：象徴コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 87,
            "PromoteMarkName": "０１：象徴コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 87,
            "PromoteMarkName": "０１：象徴コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 87,
            "PromoteMarkName": "０１：象徴コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 87,
            "PromoteMarkName": "０１：象徴コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 87,
            "PromoteMarkName": "０１：象徴コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 87,
            "PromoteMarkName": "０１：象徴コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 87,
            "PromoteMarkName": "０１：象徴コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 87,
            "PromoteMarkName": "０１：象徴コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 88,
            "PromoteMarkName": "０１：価値コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 88,
            "PromoteMarkName": "０１：価値コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 88,
            "PromoteMarkName": "０１：価値コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 88,
            "PromoteMarkName": "０１：価値コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 88,
            "PromoteMarkName": "０１：価値コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 88,
            "PromoteMarkName": "０１：価値コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 88,
            "PromoteMarkName": "０１：価値コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 88,
            "PromoteMarkName": "０１：価値コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 88,
            "PromoteMarkName": "０１：価値コマ",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 89,
            "PromoteMarkName": "０２：予約限定品",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 89,
            "PromoteMarkName": "０２：予約限定品",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 89,
            "PromoteMarkName": "０２：予約限定品",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 89,
            "PromoteMarkName": "０２：予約限定品",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 89,
            "PromoteMarkName": "０２：予約限定品",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 89,
            "PromoteMarkName": "０２：予約限定品",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 89,
            "PromoteMarkName": "０２：予約限定品",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 89,
            "PromoteMarkName": "０２：予約限定品",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 89,
            "PromoteMarkName": "０２：予約限定品",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 90,
            "PromoteMarkName": "０２：昨年人気（クリスマス）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 90,
            "PromoteMarkName": "０２：昨年人気（クリスマス）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 90,
            "PromoteMarkName": "０２：昨年人気（クリスマス）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 90,
            "PromoteMarkName": "０２：昨年人気（クリスマス）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 90,
            "PromoteMarkName": "０２：昨年人気（クリスマス）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 90,
            "PromoteMarkName": "０２：昨年人気（クリスマス）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 90,
            "PromoteMarkName": "０２：昨年人気（クリスマス）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 90,
            "PromoteMarkName": "０２：昨年人気（クリスマス）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 90,
            "PromoteMarkName": "０２：昨年人気（クリスマス）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 91,
            "PromoteMarkName": "０２：昨年人気（迎春）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 91,
            "PromoteMarkName": "０２：昨年人気（迎春）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 91,
            "PromoteMarkName": "０２：昨年人気（迎春）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 91,
            "PromoteMarkName": "０２：昨年人気（迎春）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 91,
            "PromoteMarkName": "０２：昨年人気（迎春）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 91,
            "PromoteMarkName": "０２：昨年人気（迎春）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 91,
            "PromoteMarkName": "０２：昨年人気（迎春）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 91,
            "PromoteMarkName": "０２：昨年人気（迎春）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 91,
            "PromoteMarkName": "０２：昨年人気（迎春）",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 94,
            "PromoteMarkName": "０１：特集９２～９３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 94,
            "PromoteMarkName": "０１：特集９２～９３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 94,
            "PromoteMarkName": "０１：特集９２～９３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 94,
            "PromoteMarkName": "０１：特集９２～９３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 94,
            "PromoteMarkName": "０１：特集９２～９３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 94,
            "PromoteMarkName": "０１：特集９２～９３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 94,
            "PromoteMarkName": "０１：特集９２～９３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 94,
            "PromoteMarkName": "０１：特集９２～９３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 94,
            "PromoteMarkName": "０１：特集９２～９３頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 95,
            "PromoteMarkName": "０１：特集９４～９５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 95,
            "PromoteMarkName": "０１：特集９４～９５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 95,
            "PromoteMarkName": "０１：特集９４～９５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 95,
            "PromoteMarkName": "０１：特集９４～９５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 95,
            "PromoteMarkName": "０１：特集９４～９５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 95,
            "PromoteMarkName": "０１：特集９４～９５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 95,
            "PromoteMarkName": "０１：特集９４～９５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 95,
            "PromoteMarkName": "０１：特集９４～９５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 95,
            "PromoteMarkName": "０１：特集９４～９５頁掲載",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 96,
            "PromoteMarkName": "０１：特集　買取１",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 96,
            "PromoteMarkName": "０１：特集　買取１",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 96,
            "PromoteMarkName": "０１：特集　買取１",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 96,
            "PromoteMarkName": "０１：特集　買取１",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 96,
            "PromoteMarkName": "０１：特集　買取１",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 96,
            "PromoteMarkName": "０１：特集　買取１",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 96,
            "PromoteMarkName": "０１：特集　買取１",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 96,
            "PromoteMarkName": "０１：特集　買取１",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 96,
            "PromoteMarkName": "０１：特集　買取１",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 97,
            "PromoteMarkName": "０１：特集　買取２",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 97,
            "PromoteMarkName": "０１：特集　買取２",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 97,
            "PromoteMarkName": "０１：特集　買取２",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 97,
            "PromoteMarkName": "０１：特集　買取２",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 97,
            "PromoteMarkName": "０１：特集　買取２",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 97,
            "PromoteMarkName": "０１：特集　買取２",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 97,
            "PromoteMarkName": "０１：特集　買取２",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 97,
            "PromoteMarkName": "０１：特集　買取２",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 97,
            "PromoteMarkName": "０１：特集　買取２",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 98,
            "PromoteMarkName": "０１：特集　買取３",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 98,
            "PromoteMarkName": "０１：特集　買取３",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 98,
            "PromoteMarkName": "０１：特集　買取３",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 98,
            "PromoteMarkName": "０１：特集　買取３",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 98,
            "PromoteMarkName": "０１：特集　買取３",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 98,
            "PromoteMarkName": "０１：特集　買取３",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 98,
            "PromoteMarkName": "０１：特集　買取３",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 98,
            "PromoteMarkName": "０１：特集　買取３",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 98,
            "PromoteMarkName": "０１：特集　買取３",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 99,
            "PromoteMarkName": "０１：特集　買取４",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 99,
            "PromoteMarkName": "０１：特集　買取４",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 99,
            "PromoteMarkName": "０１：特集　買取４",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 99,
            "PromoteMarkName": "０１：特集　買取４",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 99,
            "PromoteMarkName": "０１：特集　買取４",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 99,
            "PromoteMarkName": "０１：特集　買取４",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 99,
            "PromoteMarkName": "０１：特集　買取４",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 99,
            "PromoteMarkName": "０１：特集　買取４",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 99,
            "PromoteMarkName": "０１：特集　買取４",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 101,
            "PromoteMarkName": "０１：いつもお買得",
            "PromoteMarkGroupName": "ＥＤＬＰ",
            "PromoteMarkGroupCodeName": "03:ＥＤＬＰ",
            "PromoteMarkGroupCode": "03"
          },
          {
            "PromoteMarkCode": 101,
            "PromoteMarkName": "０１：いつもお買得",
            "PromoteMarkGroupName": "ＥＤＬＰ",
            "PromoteMarkGroupCodeName": "03:ＥＤＬＰ",
            "PromoteMarkGroupCode": "03"
          },
          {
            "PromoteMarkCode": 101,
            "PromoteMarkName": "０１：いつもお買得",
            "PromoteMarkGroupName": "ＥＤＬＰ",
            "PromoteMarkGroupCodeName": "03:ＥＤＬＰ",
            "PromoteMarkGroupCode": "03"
          },
          {
            "PromoteMarkCode": 101,
            "PromoteMarkName": "０１：いつもお買得",
            "PromoteMarkGroupName": "ＥＤＬＰ",
            "PromoteMarkGroupCodeName": "03:ＥＤＬＰ",
            "PromoteMarkGroupCode": "03"
          },
          {
            "PromoteMarkCode": 101,
            "PromoteMarkName": "０１：いつもお買得",
            "PromoteMarkGroupName": "ＥＤＬＰ",
            "PromoteMarkGroupCodeName": "03:ＥＤＬＰ",
            "PromoteMarkGroupCode": "03"
          },
          {
            "PromoteMarkCode": 101,
            "PromoteMarkName": "０１：いつもお買得",
            "PromoteMarkGroupName": "ＥＤＬＰ",
            "PromoteMarkGroupCodeName": "03:ＥＤＬＰ",
            "PromoteMarkGroupCode": "03"
          },
          {
            "PromoteMarkCode": 101,
            "PromoteMarkName": "０１：いつもお買得",
            "PromoteMarkGroupName": "ＥＤＬＰ",
            "PromoteMarkGroupCodeName": "03:ＥＤＬＰ",
            "PromoteMarkGroupCode": "03"
          },
          {
            "PromoteMarkCode": 101,
            "PromoteMarkName": "０１：いつもお買得",
            "PromoteMarkGroupName": "ＥＤＬＰ",
            "PromoteMarkGroupCodeName": "03:ＥＤＬＰ",
            "PromoteMarkGroupCode": "03"
          },
          {
            "PromoteMarkCode": 101,
            "PromoteMarkName": "０１：いつもお買得",
            "PromoteMarkGroupName": "ＥＤＬＰ",
            "PromoteMarkGroupCodeName": "03:ＥＤＬＰ",
            "PromoteMarkGroupCode": "03"
          },
          {
            "PromoteMarkCode": 113,
            "PromoteMarkName": "０２：タイムセール",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 113,
            "PromoteMarkName": "０２：タイムセール",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 113,
            "PromoteMarkName": "０２：タイムセール",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 113,
            "PromoteMarkName": "０２：タイムセール",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 113,
            "PromoteMarkName": "０２：タイムセール",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 113,
            "PromoteMarkName": "０２：タイムセール",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 113,
            "PromoteMarkName": "０２：タイムセール",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 113,
            "PromoteMarkName": "０２：タイムセール",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 113,
            "PromoteMarkName": "０２：タイムセール",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 116,
            "PromoteMarkName": "０１：ナチュラル２～３頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 116,
            "PromoteMarkName": "０１：ナチュラル２～３頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 116,
            "PromoteMarkName": "０１：ナチュラル２～３頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 116,
            "PromoteMarkName": "０１：ナチュラル２～３頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 116,
            "PromoteMarkName": "０１：ナチュラル２～３頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 116,
            "PromoteMarkName": "０１：ナチュラル２～３頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 116,
            "PromoteMarkName": "０１：ナチュラル２～３頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 116,
            "PromoteMarkName": "０１：ナチュラル２～３頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 116,
            "PromoteMarkName": "０１：ナチュラル２～３頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 117,
            "PromoteMarkName": "０１：ナチュラル４～５頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 117,
            "PromoteMarkName": "０１：ナチュラル４～５頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 117,
            "PromoteMarkName": "０１：ナチュラル４～５頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 117,
            "PromoteMarkName": "０１：ナチュラル４～５頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 117,
            "PromoteMarkName": "０１：ナチュラル４～５頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 117,
            "PromoteMarkName": "０１：ナチュラル４～５頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 117,
            "PromoteMarkName": "０１：ナチュラル４～５頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 117,
            "PromoteMarkName": "０１：ナチュラル４～５頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 117,
            "PromoteMarkName": "０１：ナチュラル４～５頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 118,
            "PromoteMarkName": "０１：ナチュラル６～７頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 118,
            "PromoteMarkName": "０１：ナチュラル６～７頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 118,
            "PromoteMarkName": "０１：ナチュラル６～７頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 118,
            "PromoteMarkName": "０１：ナチュラル６～７頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 118,
            "PromoteMarkName": "０１：ナチュラル６～７頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 118,
            "PromoteMarkName": "０１：ナチュラル６～７頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 118,
            "PromoteMarkName": "０１：ナチュラル６～７頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 118,
            "PromoteMarkName": "０１：ナチュラル６～７頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 118,
            "PromoteMarkName": "０１：ナチュラル６～７頁",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 160,
            "PromoteMarkName": "０１：ナチュラル　表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 160,
            "PromoteMarkName": "０１：ナチュラル　表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 160,
            "PromoteMarkName": "０１：ナチュラル　表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 160,
            "PromoteMarkName": "０１：ナチュラル　表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 160,
            "PromoteMarkName": "０１：ナチュラル　表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 160,
            "PromoteMarkName": "０１：ナチュラル　表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 160,
            "PromoteMarkName": "０１：ナチュラル　表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 160,
            "PromoteMarkName": "０１：ナチュラル　表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 160,
            "PromoteMarkName": "０１：ナチュラル　表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 161,
            "PromoteMarkName": "０１：ナチュラル　裏表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 161,
            "PromoteMarkName": "０１：ナチュラル　裏表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 161,
            "PromoteMarkName": "０１：ナチュラル　裏表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 161,
            "PromoteMarkName": "０１：ナチュラル　裏表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 161,
            "PromoteMarkName": "０１：ナチュラル　裏表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 161,
            "PromoteMarkName": "０１：ナチュラル　裏表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 161,
            "PromoteMarkName": "０１：ナチュラル　裏表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 161,
            "PromoteMarkName": "０１：ナチュラル　裏表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 161,
            "PromoteMarkName": "０１：ナチュラル　裏表紙",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 182,
            "PromoteMarkName": "０１：【秋】お買い得期間",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 182,
            "PromoteMarkName": "０１：【秋】お買い得期間",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 182,
            "PromoteMarkName": "０１：【秋】お買い得期間",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 182,
            "PromoteMarkName": "０１：【秋】お買い得期間",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 182,
            "PromoteMarkName": "０１：【秋】お買い得期間",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 182,
            "PromoteMarkName": "０１：【秋】お買い得期間",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 182,
            "PromoteMarkName": "０１：【秋】お買い得期間",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 182,
            "PromoteMarkName": "０１：【秋】お買い得期間",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 182,
            "PromoteMarkName": "０１：【秋】お買い得期間",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 185,
            "PromoteMarkName": "９９：期間限定テーマ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 185,
            "PromoteMarkName": "９９：期間限定テーマ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 185,
            "PromoteMarkName": "９９：期間限定テーマ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 185,
            "PromoteMarkName": "９９：期間限定テーマ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 185,
            "PromoteMarkName": "９９：期間限定テーマ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 185,
            "PromoteMarkName": "９９：期間限定テーマ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 185,
            "PromoteMarkName": "９９：期間限定テーマ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 185,
            "PromoteMarkName": "９９：期間限定テーマ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 185,
            "PromoteMarkName": "９９：期間限定テーマ",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 217,
            "PromoteMarkName": "０２：新米",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 217,
            "PromoteMarkName": "０２：新米",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 217,
            "PromoteMarkName": "０２：新米",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 217,
            "PromoteMarkName": "０２：新米",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 217,
            "PromoteMarkName": "０２：新米",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 217,
            "PromoteMarkName": "０２：新米",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 217,
            "PromoteMarkName": "０２：新米",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 217,
            "PromoteMarkName": "０２：新米",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 217,
            "PromoteMarkName": "０２：新米",
            "PromoteMarkGroupName": "促進マーク",
            "PromoteMarkGroupCodeName": "02:促進マーク",
            "PromoteMarkGroupCode": "02"
          },
          {
            "PromoteMarkCode": 799,
            "PromoteMarkName": "９９：にいがた大好き！",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 799,
            "PromoteMarkName": "９９：にいがた大好き！",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 799,
            "PromoteMarkName": "９９：にいがた大好き！",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 799,
            "PromoteMarkName": "９９：にいがた大好き！",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 799,
            "PromoteMarkName": "９９：にいがた大好き！",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 799,
            "PromoteMarkName": "９９：にいがた大好き！",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 799,
            "PromoteMarkName": "９９：にいがた大好き！",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 799,
            "PromoteMarkName": "９９：にいがた大好き！",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 799,
            "PromoteMarkName": "９９：にいがた大好き！",
            "PromoteMarkGroupName": "地域ページ",
            "PromoteMarkGroupCodeName": "08:地域ページ",
            "PromoteMarkGroupCode": "08"
          },
          {
            "PromoteMarkCode": 994,
            "PromoteMarkName": "９９：いきいきくらす識別",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 994,
            "PromoteMarkName": "９９：いきいきくらす識別",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 994,
            "PromoteMarkName": "９９：いきいきくらす識別",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 994,
            "PromoteMarkName": "９９：いきいきくらす識別",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 994,
            "PromoteMarkName": "９９：いきいきくらす識別",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 994,
            "PromoteMarkName": "９９：いきいきくらす識別",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 994,
            "PromoteMarkName": "９９：いきいきくらす識別",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 994,
            "PromoteMarkName": "９９：いきいきくらす識別",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          },
          {
            "PromoteMarkCode": 994,
            "PromoteMarkName": "９９：いきいきくらす識別",
            "PromoteMarkGroupName": "供給（予備）",
            "PromoteMarkGroupCodeName": "11:供給（予備）",
            "PromoteMarkGroupCode": "11"
          }
        ],
        "EcologyDivList": [
          {
            "EcologyDiv": "01",
            "EcologyDivName": "日生協環境商品"
          },
          {
            "EcologyDiv": "02",
            "EcologyDivName": "日生協ちょこっとエコ商品"
          },
          {
            "EcologyDiv": "03",
            "EcologyDivName": "エコマーク商品"
          },
          {
            "EcologyDiv": "04",
            "EcologyDivName": "グリーンマーク商品"
          },
          {
            "EcologyDiv": "05",
            "EcologyDivName": "再生紙Ｒマーク商品"
          },
          {
            "EcologyDiv": "06",
            "EcologyDivName": "ＰＥＴボトルリサイクルマーク"
          },
          {
            "EcologyDiv": "07",
            "EcologyDivName": "飲料品紙容器マーク"
          },
          {
            "EcologyDiv": "08",
            "EcologyDivName": "ＪＡＳ有機・特別栽培農産物"
          },
          {
            "EcologyDiv": "09",
            "EcologyDivName": "その他の環境配慮商品"
          },
          {
            "EcologyDiv": "10",
            "EcologyDivName": "ＦＳＣ認証商品"
          },
          {
            "EcologyDiv": "11",
            "EcologyDivName": "ＭＳＣ認証商品"
          }
        ],
        "ContainList": [
          {
            "ContainDiv": "100",
            "ContainDivName": "ガラス製",
            "ContainKind": "101",
            "ContainKindName": "ガラスびん無色"
          },
          {
            "ContainDiv": "100",
            "ContainDivName": "ガラス製",
            "ContainKind": "102",
            "ContainKindName": "ガラスびん茶色"
          },
          {
            "ContainDiv": "100",
            "ContainDivName": "ガラス製",
            "ContainKind": "103",
            "ContainKindName": "ガラスびんその他"
          },
          {
            "ContainDiv": "200",
            "ContainDivName": "ＰＥＴボトル",
            "ContainKind": "200",
            "ContainKindName": "ＰＥＴボトル"
          },
          {
            "ContainDiv": "300",
            "ContainDivName": "紙パック",
            "ContainKind": "301",
            "ContainKindName": "紙パック"
          },
          {
            "ContainDiv": "300",
            "ContainDivName": "紙パック",
            "ContainKind": "302",
            "ContainKindName": "紙パック（アルミ付き）"
          },
          {
            "ContainDiv": "400",
            "ContainDivName": "紙製容器",
            "ContainKind": "400",
            "ContainKindName": "紙製容器"
          },
          {
            "ContainDiv": "500",
            "ContainDivName": "紙製包装",
            "ContainKind": "500",
            "ContainKindName": "紙製包装"
          },
          {
            "ContainDiv": "600",
            "ContainDivName": "プラスティック製容器",
            "ContainKind": "601",
            "ContainKindName": "ＰＥＴ"
          },
          {
            "ContainDiv": "600",
            "ContainDivName": "プラスティック製容器",
            "ContainKind": "602",
            "ContainKindName": "ＰＰ"
          },
          {
            "ContainDiv": "600",
            "ContainDivName": "プラスティック製容器",
            "ContainKind": "603",
            "ContainKindName": "ＰＳ"
          },
          {
            "ContainDiv": "600",
            "ContainDivName": "プラスティック製容器",
            "ContainKind": "604",
            "ContainKindName": "ＰＥ"
          },
          {
            "ContainDiv": "600",
            "ContainDivName": "プラスティック製容器",
            "ContainKind": "605",
            "ContainKindName": "複合・その他"
          },
          {
            "ContainDiv": "700",
            "ContainDivName": "プラスティック製包装",
            "ContainKind": "701",
            "ContainKindName": "ＰＥＴ"
          },
          {
            "ContainDiv": "700",
            "ContainDivName": "プラスティック製包装",
            "ContainKind": "702",
            "ContainKindName": "ＰＰ"
          },
          {
            "ContainDiv": "700",
            "ContainDivName": "プラスティック製包装",
            "ContainKind": "703",
            "ContainKindName": "ＰＳ"
          },
          {
            "ContainDiv": "700",
            "ContainDivName": "プラスティック製包装",
            "ContainKind": "704",
            "ContainKindName": "ＰＥ"
          },
          {
            "ContainDiv": "700",
            "ContainDivName": "プラスティック製包装",
            "ContainKind": "705",
            "ContainKindName": "複合・その他"
          },
          {
            "ContainDiv": "800",
            "ContainDivName": "缶",
            "ContainKind": "801",
            "ContainKindName": "アルミ缶"
          },
          {
            "ContainDiv": "800",
            "ContainDivName": "缶",
            "ContainKind": "802",
            "ContainKindName": "スチール缶"
          }
        ],
        "GWStopGoodsList": [
          {
            "GWStopGoodsDiv": "01",
            "GWStopGoodsDivName": "カーボンオフセット商品"
          },
          {
            "GWStopGoodsDiv": "02",
            "GWStopGoodsDivName": "カーボンフットプリント商品"
          }
        ]
      },
      "getPlanGoodsItemVO": {
        "ItemCodeList": [
          {
            "ItemCodeCommon": {
              "OrderCode": "2023320",
              "ItemCode": "4430409",
              "PCode": "P2670878",
              "JANCode": "4952993509090",
              "JANCodeDiv": "0"
            },
            "ItemCodeBase": {
              "SpecialOrderType": "00",
              "StockType": "1",
              "InstallmentTimes": 1,
              "OrderUnitType": "2",
              "PriceType": "",
              "MakerPrice": null,
              "OrderClientCode": "947164",
              "OrderClientName": "ロジネット入間物流",
              "PayeeClientCode": "941069",
              "PayeeClientName": "北海道漁連（水産）",
              "BundlePrice": 1,
              "FixContainNum": 60,
              "SetQuantity": 1,
              "FCMCFee": null,
              "PDPilingUpDays": 2,
              "ITFCode": ""
            },
            "ItemCodeSpec1": {
              "EBaseSpecCode": "E4923121-N5V52884-N5V52884",
              "SpecApplyDate": "2023/04/12",
              "MakerName": "トナミ食品",
              "MakerNamePublishType": "1",
              "PeaceSizeLength": 175,
              "PeaceSizeWidth": 120,
              "PeaceSizeHight": 50,
              "PeaceWeight": 113,
              "CaseSizeLength": 430,
              "CaseSizeWidth": 346,
              "CaseSizeHight": 220,
              "CaseWeight": 7430,
              "TextInfoList": [
                {
                  "TextKindID": "005",
                  "PublishFlag": "1",
                  "StringValue": "製造北海道。主要な原材料するめいか（北海道）、ミズダコ（北海道）、めかぶ（北海道）。",
                  "EFriendsFlag": "0"
                },
                {
                  "TextKindID": "014",
                  "PublishFlag": "0",
                  "StringValue": "原材料名：スルメイカ（北海道沖）、ミズダコ（北海道沖）、メカブ（北海道沖）、しょうゆ加工品（しょうゆ、砂糖、食塩、削り節（さば・あじ・かつお））、砂糖、麦芽糖調製品、食塩／調味料（アミノ酸等）、カラメル色素、増粘多糖類、（一部に小麦・いか・さば・大豆を含む）",
                  "EFriendsFlag": "1"
                },
                {
                  "TextKindID": "013",
                  "PublishFlag": "0",
                  "StringValue": "",
                  "EFriendsFlag": "0"
                },
                {
                  "TextKindID": "010",
                  "PublishFlag": "0",
                  "StringValue": "",
                  "EFriendsFlag": "0"
                },
                {
                  "TextKindID": "006",
                  "PublishFlag": "0",
                  "StringValue": "",
                  "EFriendsFlag": "0"
                },
                {
                  "TextKindID": "007",
                  "PublishFlag": "0",
                  "StringValue": "",
                  "EFriendsFlag": "0"
                }
              ],
              "GeneRecombinationDiv": "0"
            },
            "ItemCodeSpec2": {
              "AllergenTargetType": "0",
              "AnalysisUnit": "",
              "Calorie": null,
              "Protein": "",
              "Lipid": "",
              "Carbohydrate": "",
              "Sodium": "",
              "AllergenList": [
                {
                  "AllergenDiv": "001",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "002",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "003",
                  "AllergenSelect": "1",
                  "ComponentAllergenSelect": "レ"
                },
                {
                  "AllergenDiv": "004",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "005",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "006",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "007",
                  "AllergenSelect": "1",
                  "ComponentAllergenSelect": "レ"
                },
                {
                  "AllergenDiv": "008",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "009",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "010",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "011",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "012",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "013",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "014",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "015",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "016",
                  "AllergenSelect": "1",
                  "ComponentAllergenSelect": "レ"
                },
                {
                  "AllergenDiv": "017",
                  "AllergenSelect": "1",
                  "ComponentAllergenSelect": "レ"
                },
                {
                  "AllergenDiv": "018",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "019",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "020",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "021",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "022",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "023",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "024",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "025",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "026",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "027",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "028",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "029",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                },
                {
                  "AllergenDiv": "030",
                  "AllergenSelect": "0",
                  "ComponentAllergenSelect": ""
                }
              ]
            },
            "ItemCodeNutritional": {
              "List": [
                {
                  "AnalysisSeqNo": 0,
                  "AnalysisUnit": "100g",
                  "NutritionalNote": "※この表示値は目安です。",
                  "NutrientComponentList": {
                    "List": [
                      {
                        "NutritionalName": "エネルギー",
                        "NutritionalQuantity": "64",
                        "NutritionalUnit": "kcal",
                        "NutritionalCode": "001",
                        "PublishDiv": "1",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "たんぱく質",
                        "NutritionalQuantity": "11.4",
                        "NutritionalUnit": "g",
                        "NutritionalCode": "002",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "脂質",
                        "NutritionalQuantity": "0.6",
                        "NutritionalUnit": "g",
                        "NutritionalCode": "003",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "炭水化物",
                        "NutritionalQuantity": "4.1",
                        "NutritionalUnit": "g",
                        "NutritionalCode": "004",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "食塩相当量",
                        "NutritionalQuantity": "1.5",
                        "NutritionalUnit": "g",
                        "NutritionalCode": "006",
                        "PublishDiv": "1",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "　飽和脂肪酸",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "g",
                        "NutritionalCode": "032",
                        "PublishDiv": "0",
                        "Hirearchy": "2"
                      },
                      {
                        "NutritionalName": "　ｎ－３系脂肪酸",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "g",
                        "NutritionalCode": "033",
                        "PublishDiv": "0",
                        "Hirearchy": "2"
                      },
                      {
                        "NutritionalName": "　ｎ－６系脂肪酸",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "g",
                        "NutritionalCode": "034",
                        "PublishDiv": "0",
                        "Hirearchy": "2"
                      },
                      {
                        "NutritionalName": "　トランス脂肪酸",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "g",
                        "NutritionalCode": "035",
                        "PublishDiv": "0",
                        "Hirearchy": "2"
                      },
                      {
                        "NutritionalName": "　コレステロール",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "036",
                        "PublishDiv": "0",
                        "Hirearchy": "2"
                      },
                      {
                        "NutritionalName": "　糖質",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "g",
                        "NutritionalCode": "037",
                        "PublishDiv": "0",
                        "Hirearchy": "2"
                      },
                      {
                        "NutritionalName": "　糖類",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "g",
                        "NutritionalCode": "038",
                        "PublishDiv": "0",
                        "Hirearchy": "2"
                      },
                      {
                        "NutritionalName": "　食物繊維",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "g",
                        "NutritionalCode": "039",
                        "PublishDiv": "0",
                        "Hirearchy": "2"
                      },
                      {
                        "NutritionalName": "ナトリウム",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "005",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "食塩相当量（計算値）",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "g",
                        "NutritionalCode": "901",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "亜鉛",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "007",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "カリウム",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "008",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "カルシウム",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "009",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "クロム",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "μｇ",
                        "NutritionalCode": "010",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "セレン",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "μｇ",
                        "NutritionalCode": "011",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "鉄",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "012",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "銅",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "013",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "マグネシウム",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "014",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "マンガン",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "015",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "モリブデン",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "μｇ",
                        "NutritionalCode": "016",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "ヨウ素",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "μｇ",
                        "NutritionalCode": "017",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "リン",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "018",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "ナイアシン",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "019",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "パントテン酸",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "020",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "ビオチン",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "μｇ",
                        "NutritionalCode": "021",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "ビタミンＡ",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "μｇ",
                        "NutritionalCode": "022",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "ビタミンＢ１",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "023",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "ビタミンＢ２",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "024",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "ビタミンＢ６",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "025",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "ビタミンＢ１２",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "μｇ",
                        "NutritionalCode": "026",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "ビタミンＣ",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "027",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "ビタミンＤ",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "μｇ",
                        "NutritionalCode": "028",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "ビタミンＥ",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "mg",
                        "NutritionalCode": "029",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "ビタミンＫ",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "μｇ",
                        "NutritionalCode": "030",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      },
                      {
                        "NutritionalName": "葉酸",
                        "NutritionalQuantity": "",
                        "NutritionalUnit": "μｇ",
                        "NutritionalCode": "031",
                        "PublishDiv": "0",
                        "Hirearchy": "1"
                      }
                    ]
                  }
                }
              ]
            },
            "ItemCodeNutritionalMulti": {
              "List": []
            },
            "ItemCodeEcology": {
              "EcologyDivFlag": "0",
              "EcologyDivList": [
                {
                  "EcologyDiv": "01",
                  "EcologyDivSelect": "0"
                },
                {
                  "EcologyDiv": "02",
                  "EcologyDivSelect": "0"
                },
                {
                  "EcologyDiv": "03",
                  "EcologyDivSelect": "0"
                },
                {
                  "EcologyDiv": "04",
                  "EcologyDivSelect": "0"
                },
                {
                  "EcologyDiv": "05",
                  "EcologyDivSelect": "0"
                },
                {
                  "EcologyDiv": "06",
                  "EcologyDivSelect": "0"
                },
                {
                  "EcologyDiv": "07",
                  "EcologyDivSelect": "0"
                },
                {
                  "EcologyDiv": "08",
                  "EcologyDivSelect": "0"
                },
                {
                  "EcologyDiv": "09",
                  "EcologyDivSelect": "0"
                },
                {
                  "EcologyDiv": "10",
                  "EcologyDivSelect": "0"
                },
                {
                  "EcologyDiv": "11",
                  "EcologyDivSelect": "0"
                }
              ],
              "GWStopGoodsList": [
                {
                  "GWStopGoodsDiv": "01",
                  "GWStopGoodsDivSelect": "0"
                },
                {
                  "GWStopGoodsDiv": "02",
                  "GWStopGoodsDivSelect": "0"
                }
              ],
              "ContainList": [
                {
                  "ContainDiv": "100",
                  "ContainKind": "101",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "100",
                  "ContainKind": "102",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "100",
                  "ContainKind": "103",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "200",
                  "ContainKind": "200",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "300",
                  "ContainKind": "301",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "300",
                  "ContainKind": "302",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "400",
                  "ContainKind": "400",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "500",
                  "ContainKind": "500",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "600",
                  "ContainKind": "601",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "600",
                  "ContainKind": "602",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "600",
                  "ContainKind": "603",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "600",
                  "ContainKind": "604",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "600",
                  "ContainKind": "605",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "700",
                  "ContainKind": "701",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "700",
                  "ContainKind": "702",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "700",
                  "ContainKind": "703",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "700",
                  "ContainKind": "704",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "700",
                  "ContainKind": "705",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "800",
                  "ContainKind": "801",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                },
                {
                  "ContainDiv": "800",
                  "ContainKind": "802",
                  "PackMaterialWeight": null,
                  "ContainSelect": "0"
                }
              ]
            }
          }
        ],
        "ItemCodePromote": {
          "PromoteMarkList": [
            {
              "PromoteMarkCode": "6",
              "PromoteMarkName": "０１：今週のお買得",
              "PromoteMarkGroupCode": "01",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "12",
              "PromoteMarkName": "０１：くらし応援",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "13",
              "PromoteMarkName": "０１：くらし応援 さらにお得",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "14",
              "PromoteMarkName": "０１：週次テーマ１",
              "PromoteMarkGroupCode": "11",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "15",
              "PromoteMarkName": "０１：週次テーマ２",
              "PromoteMarkGroupCode": "11",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "16",
              "PromoteMarkName": "０１：包材変更可能性あり",
              "PromoteMarkGroupCode": "05",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "17",
              "PromoteMarkName": "０１：おかずのヒント",
              "PromoteMarkGroupCode": "11",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "18",
              "PromoteMarkName": "０１：訴求チラシ",
              "PromoteMarkGroupCode": "11",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "22",
              "PromoteMarkName": "０２：旬",
              "PromoteMarkGroupCode": "11",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "25",
              "PromoteMarkName": "０１：特集ページ",
              "PromoteMarkGroupCode": "11",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "31",
              "PromoteMarkName": "９９：県内産",
              "PromoteMarkGroupCode": "08",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "33",
              "PromoteMarkName": "０１：数量限定",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "48",
              "PromoteMarkName": "０２：忘れず注文",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "50",
              "PromoteMarkName": "０１：最安値",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "53",
              "PromoteMarkName": "０１：おためし価格",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "54",
              "PromoteMarkName": "０２：予約",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "58",
              "PromoteMarkName": "０１：今回より値下げ",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "59",
              "PromoteMarkName": "０１：今回より値上げ",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "60",
              "PromoteMarkName": "０１：次回より値上げ",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "61",
              "PromoteMarkName": "０１：今回より減量",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "62",
              "PromoteMarkName": "０１：次回より減量",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "63",
              "PromoteMarkName": "０１：今回より増量",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "69",
              "PromoteMarkName": "０１：ポイント利用",
              "PromoteMarkGroupCode": "11",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "70",
              "PromoteMarkName": "０１：特集２～３頁掲載",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "71",
              "PromoteMarkName": "０１：特集４～５頁掲載",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "72",
              "PromoteMarkName": "０１：特集６～７頁掲載",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "73",
              "PromoteMarkName": "０１：特集８～９頁掲載",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "74",
              "PromoteMarkName": "０１：特集１０～１１頁掲載",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "75",
              "PromoteMarkName": "０１：特集１２～１３頁掲載",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "76",
              "PromoteMarkName": "０１：特集１４～１５頁掲載",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "77",
              "PromoteMarkName": "０１：特集１６～１７頁掲載",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "78",
              "PromoteMarkName": "０１：特集１８～１９頁掲載",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "79",
              "PromoteMarkName": "０１：特集２０～２１頁掲載",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "80",
              "PromoteMarkName": "０１：特集　美容健康",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "81",
              "PromoteMarkName": "０１：特集　ラクデリ（とうきょうのみ）",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "84",
              "PromoteMarkName": "０１：特集　朝食応援",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "87",
              "PromoteMarkName": "０１：象徴コマ",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "88",
              "PromoteMarkName": "０１：価値コマ",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "89",
              "PromoteMarkName": "０２：予約限定品",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "90",
              "PromoteMarkName": "０２：昨年人気（クリスマス）",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "91",
              "PromoteMarkName": "０２：昨年人気（迎春）",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "94",
              "PromoteMarkName": "０１：特集９２～９３頁掲載",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "95",
              "PromoteMarkName": "０１：特集９４～９５頁掲載",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "96",
              "PromoteMarkName": "０１：特集　買取１",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "97",
              "PromoteMarkName": "０１：特集　買取２",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "98",
              "PromoteMarkName": "０１：特集　買取３",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "99",
              "PromoteMarkName": "０１：特集　買取４",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "101",
              "PromoteMarkName": "０１：いつもお買得",
              "PromoteMarkGroupCode": "03",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "113",
              "PromoteMarkName": "０２：タイムセール",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "116",
              "PromoteMarkName": "０１：ナチュラル２～３頁",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "117",
              "PromoteMarkName": "０１：ナチュラル４～５頁",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "118",
              "PromoteMarkName": "０１：ナチュラル６～７頁",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "160",
              "PromoteMarkName": "０１：ナチュラル　表紙",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "161",
              "PromoteMarkName": "０１：ナチュラル　裏表紙",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "182",
              "PromoteMarkName": "０１：【秋】お買い得期間",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "185",
              "PromoteMarkName": "９９：期間限定テーマ",
              "PromoteMarkGroupCode": "11",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "217",
              "PromoteMarkName": "０２：新米",
              "PromoteMarkGroupCode": "02",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "799",
              "PromoteMarkName": "９９：にいがた大好き！",
              "PromoteMarkGroupCode": "08",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            },
            {
              "PromoteMarkCode": "994",
              "PromoteMarkName": "９９：いきいきくらす識別",
              "PromoteMarkGroupCode": "11",
              "PromoteMark0": "0",
              "PromoteMark1": "0",
              "PromoteMark2": "0",
              "PromoteMark3": "0",
              "PromoteMark4": "0",
              "PromoteMark5": "0",
              "PromoteMark6": "0",
              "PromoteMark7": "0"
            }
          ]
        },
        "CodeMasterpNutritional": {
          "CodeMasterpNutritionalList": [
            {
              "SeqNo": 1,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "001",
              "NutritionalName": "エネルギー",
              "NutritionalQuantity": "",
              "NutritionalUnit": "kcal",
              "PublishDiv": "1",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 2,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "002",
              "NutritionalName": "たんぱく質",
              "NutritionalQuantity": "",
              "NutritionalUnit": "g",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 3,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "003",
              "NutritionalName": "脂質",
              "NutritionalQuantity": "",
              "NutritionalUnit": "g",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 4,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "032",
              "NutritionalName": "　飽和脂肪酸",
              "NutritionalQuantity": "",
              "NutritionalUnit": "g",
              "PublishDiv": "0",
              "Hirearchy": "2",
              "ParentNutritionalCode": "003"
            },
            {
              "SeqNo": 5,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "033",
              "NutritionalName": "　ｎ－３系脂肪酸",
              "NutritionalQuantity": "",
              "NutritionalUnit": "g",
              "PublishDiv": "0",
              "Hirearchy": "2",
              "ParentNutritionalCode": "003"
            },
            {
              "SeqNo": 6,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "034",
              "NutritionalName": "　ｎ－６系脂肪酸",
              "NutritionalQuantity": "",
              "NutritionalUnit": "g",
              "PublishDiv": "0",
              "Hirearchy": "2",
              "ParentNutritionalCode": "003"
            },
            {
              "SeqNo": 7,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "035",
              "NutritionalName": "　トランス脂肪酸",
              "NutritionalQuantity": "",
              "NutritionalUnit": "g",
              "PublishDiv": "0",
              "Hirearchy": "2",
              "ParentNutritionalCode": "003"
            },
            {
              "SeqNo": 8,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "036",
              "NutritionalName": "　コレステロール",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "2",
              "ParentNutritionalCode": "003"
            },
            {
              "SeqNo": 9,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "004",
              "NutritionalName": "炭水化物",
              "NutritionalQuantity": "",
              "NutritionalUnit": "g",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 10,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "037",
              "NutritionalName": "　糖質",
              "NutritionalQuantity": "",
              "NutritionalUnit": "g",
              "PublishDiv": "0",
              "Hirearchy": "2",
              "ParentNutritionalCode": "004"
            },
            {
              "SeqNo": 11,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "038",
              "NutritionalName": "　糖類",
              "NutritionalQuantity": "",
              "NutritionalUnit": "g",
              "PublishDiv": "0",
              "Hirearchy": "2",
              "ParentNutritionalCode": "004"
            },
            {
              "SeqNo": 12,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "039",
              "NutritionalName": "　食物繊維",
              "NutritionalQuantity": "",
              "NutritionalUnit": "g",
              "PublishDiv": "0",
              "Hirearchy": "2",
              "ParentNutritionalCode": "004"
            },
            {
              "SeqNo": 13,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "005",
              "NutritionalName": "ナトリウム",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 14,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "006",
              "NutritionalName": "食塩相当量",
              "NutritionalQuantity": "",
              "NutritionalUnit": "g",
              "PublishDiv": "1",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 15,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "901",
              "NutritionalName": "食塩相当量（計算値）",
              "NutritionalQuantity": "",
              "NutritionalUnit": "g",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 16,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "007",
              "NutritionalName": "亜鉛",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 17,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "008",
              "NutritionalName": "カリウム",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 18,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "009",
              "NutritionalName": "カルシウム",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 19,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "010",
              "NutritionalName": "クロム",
              "NutritionalQuantity": "",
              "NutritionalUnit": "μｇ",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 20,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "011",
              "NutritionalName": "セレン",
              "NutritionalQuantity": "",
              "NutritionalUnit": "μｇ",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 21,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "012",
              "NutritionalName": "鉄",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 22,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "013",
              "NutritionalName": "銅",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 23,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "014",
              "NutritionalName": "マグネシウム",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 24,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "015",
              "NutritionalName": "マンガン",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 25,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "016",
              "NutritionalName": "モリブデン",
              "NutritionalQuantity": "",
              "NutritionalUnit": "μｇ",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 26,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "017",
              "NutritionalName": "ヨウ素",
              "NutritionalQuantity": "",
              "NutritionalUnit": "μｇ",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 27,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "018",
              "NutritionalName": "リン",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 28,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "019",
              "NutritionalName": "ナイアシン",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 29,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "020",
              "NutritionalName": "パントテン酸",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 30,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "021",
              "NutritionalName": "ビオチン",
              "NutritionalQuantity": "",
              "NutritionalUnit": "μｇ",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 31,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "022",
              "NutritionalName": "ビタミンＡ",
              "NutritionalQuantity": "",
              "NutritionalUnit": "μｇ",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 32,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "023",
              "NutritionalName": "ビタミンＢ１",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 33,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "024",
              "NutritionalName": "ビタミンＢ２",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 34,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "025",
              "NutritionalName": "ビタミンＢ６",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 35,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "026",
              "NutritionalName": "ビタミンＢ１２",
              "NutritionalQuantity": "",
              "NutritionalUnit": "μｇ",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 36,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "027",
              "NutritionalName": "ビタミンＣ",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 37,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "028",
              "NutritionalName": "ビタミンＤ",
              "NutritionalQuantity": "",
              "NutritionalUnit": "μｇ",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 38,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "029",
              "NutritionalName": "ビタミンＥ",
              "NutritionalQuantity": "",
              "NutritionalUnit": "mg",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 39,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "030",
              "NutritionalName": "ビタミンＫ",
              "NutritionalQuantity": "",
              "NutritionalUnit": "μｇ",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            },
            {
              "SeqNo": 40,
              "OrderCode": "",
              "PCode": "",
              "ItemCode": "",
              "AnalysisSeqNo": null,
              "NutritionalCode": "031",
              "NutritionalName": "葉酸",
              "NutritionalQuantity": "",
              "NutritionalUnit": "μｇ",
              "PublishDiv": "0",
              "Hirearchy": "1",
              "ParentNutritionalCode": ""
            }
          ]
        }
      }
    }
  }
}

const getCoopPlanNumResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      PlanNumTotal: 23,
      CoopPlanNumList: [
        {
          CoopCode: "142",
          PlanNum: 2
        },
        {
          CoopCode: "163",
          PlanNum: 1
        },
        {
          CoopCode: "185",
          PlanNum: 2
        },
        {
          CoopCode: "240",
          PlanNum: 5
        },
        {
          CoopCode: "210",
          PlanNum: 4
        },
        {
          CoopCode: "302",
          PlanNum: 6
        },
        {
          CoopCode: "515",
          PlanNum: 2
        },
        {
          CoopCode: "451",
          PlanNum: 1
        }
      ]
    }
  }
}

const getOrderNumQuotaCodeListResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: []
  }
}

const getOrderNumQuotaCodeListResponseReqPoint = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      {
        OrderNumQuotaCode: "001",
        OrderNumQuotaName: "abc",
        DelivCatalogID: "XXX",
        DeliveryWeekFixFlag: "XXX"
      },
      {
        OrderNumQuotaCode: "002",
        OrderNumQuotaName: "def",
        DelivCatalogID: "XXX",
        DeliveryWeekFixFlag: "XXX"
      },
      {
        OrderNumQuotaCode: "003",
        OrderNumQuotaName: "ghi",
        DelivCatalogID: "XXX",
        DeliveryWeekFixFlag: "XXX"
      },
    ]
  }
}

const getOrderNumQuotaCodeListResponseReqNval = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      {
        OrderNumQuotaCode: "004",
        OrderNumQuotaName: "111",
        DelivCatalogID: "XXX",
        DeliveryWeekFixFlag: "XXX"
      },
      {
        OrderNumQuotaCode: "005",
        OrderNumQuotaName: "222",
        DelivCatalogID: "XXX",
        DeliveryWeekFixFlag: "XXX"
      },
      {
        OrderNumQuotaCode: "006",
        OrderNumQuotaName: "333",
        DelivCatalogID: "XXX",
        DeliveryWeekFixFlag: "XXX"
      },
    ]
  }
}

const getOrderNumQuotaCodeListResponseReqCoupon = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      {
        OrderNumQuotaCode: "007",
        OrderNumQuotaName: "a12",
        DelivCatalogID: "XXX",
        DeliveryWeekFixFlag: "XXX"
      },
      {
        OrderNumQuotaCode: "008",
        OrderNumQuotaName: "b34",
        DelivCatalogID: "XXX",
        DeliveryWeekFixFlag: "XXX"
      },
      {
        OrderNumQuotaCode: "009",
        OrderNumQuotaName: "c56",
        DelivCatalogID: "XXX",
        DeliveryWeekFixFlag: "XXX"
      },
    ]
  }
}

const getOrderNumQuotaCodeListResponseReqPreOrder = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      {
        OrderNumQuotaCode: "123",
        OrderNumQuotaName: "aaa",
        DelivCatalogID: "XXX",
        DeliveryWeekFixFlag: "XXX"
      },
      {
        OrderNumQuotaCode: "456",
        OrderNumQuotaName: "bbb",
        DelivCatalogID: "XXX",
        DeliveryWeekFixFlag: "XXX"
      },
      {
        OrderNumQuotaCode: "789",
        OrderNumQuotaName: "ccc",
        DelivCatalogID: "XXX",
        DeliveryWeekFixFlag: "XXX"
      },
    ]
  }
}

const getPlanGoodsLotteryPromotionResponseFlgOn = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      LotteryPromotionFlg: 1,
      PlanGoodsLotteryList: [
        {
          ItemCode: "1234567",
          WinningGoodsNum: 500,
          WinningGoodsPerPersonNum: 10,
          LimitedMeaning: "1",
          MondayPlanNum: 100,
          TuesdayPlanNum: 100,
          WednesdayPlanNum: 100,
          ThursdayPlanNum: 100,
          FridayPlanNum: 100,
        },
        {
          ItemCode: "2345678",
          WinningGoodsNum: 1000,
          WinningGoodsPerPersonNum: 20,
          LimitedMeaning: "2",
          MondayPlanNum: 200,
          TuesdayPlanNum: 200,
          WednesdayPlanNum: 200,
          ThursdayPlanNum: 200,
          FridayPlanNum: 200,
        },
        {
          ItemCode: "3456789",
          WinningGoodsNum: 1500,
          WinningGoodsPerPersonNum: 30,
          LimitedMeaning: "3",
          MondayPlanNum: 300,
          TuesdayPlanNum: 300,
          WednesdayPlanNum: 300,
          ThursdayPlanNum: 300,
          FridayPlanNum: 300,
        },
        {
          ItemCode: "4567890",
          WinningGoodsNum: 800,
          WinningGoodsPerPersonNum: 40,
          LimitedMeaning: "4",
          MondayPlanNum: 160,
          TuesdayPlanNum: 160,
          WednesdayPlanNum: 160,
          ThursdayPlanNum: 160,
          FridayPlanNum: 160,
        }
      ]      
    }
  }
}

const getPlanGoodsLotteryPromotionResponseFlgOff = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      LotteryPromotionFlg: 0,
      PlanGoodsLotteryList: []
    }
  }
}

const getNumberOfUsersResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      MondayPlanNum: '654321',
      TuesdayPlanNum: '654321',
      WednesdayPlanNum: '654321',
      ThursdayPlanNum: '654321',
      FridayPlanNum: '654321',
    }
  }
}

const getPlanGoodsPointExchangePromotionResponseFlgOn = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      PointPromotionFlg: 1,
      PointExchangeList: [
        {
          ItemCode: "1234567",
          PointExchangeOrderNumQuotaCode: "001",
          PointExchangeOrderNum: 123456,
          PointExchangeGoodsName: "ポイント商品A",
          PointExchangeGoodsNameKana: "ﾎﾟｲﾝﾄｼｮｳﾋﾝｴｰ",
          PointExchangeGuideName: "規格A",
          PointExchangeGuideNameKana: "ｷｶｸｴｰ",
          ShortOfPointDiv: 0,
          EcOnlyFlg: "1",
          ConsumeTaxRate: 10,
          CoopPointRateList: [
            {
              ItemCode: "1234567",
              CoopCode: "142",
              ThisTimeSupplyPrice: 100000000,
              PointRate: "10",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "485"
            },
            {
              ItemCode: "1234567",
              CoopCode: "163",
              ThisTimeSupplyPrice: 1000,
              PointRate: "15",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "485"
            },
            {
              ItemCode: "1234567",
              CoopCode: "185",
              ThisTimeSupplyPrice: 1000,
              PointRate: "15",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "485"
            },
            {
              ItemCode: "1234567",
              CoopCode: "240",
              ThisTimeSupplyPrice: 1000,
              PointRate: "10",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "485"
            },
            {
              ItemCode: "1234567",
              CoopCode: "210",
              ThisTimeSupplyPrice: 1000,
              PointRate: "10",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "485"
            },
            {
              ItemCode: "1234567",
              CoopCode: "302",
              ThisTimeSupplyPrice: 1000,
              PointRate: "10",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "485"
            },
            {
              ItemCode: "1234567",
              CoopCode: "515",
              ThisTimeSupplyPrice: 1000,
              PointRate: "10",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "485"
            },
            {
              ItemCode: "1234567",
              CoopCode: "451",
              ThisTimeSupplyPrice: 1000,
              PointRate: "",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "485"
            }
          ]
        },
        {
          ItemCode: "2345678",
          PointExchangeOrderNumQuotaCode: "002",
          PointExchangeOrderNum: 234567,
          PointExchangeGoodsName: "ポイント商品B",
          PointExchangeGoodsNameKana: "ﾎﾟｲﾝﾄｼｮｳﾋﾝﾋﾞｰ",
          PointExchangeGuideName: "規格B",
          PointExchangeGuideNameKana: "ｷｶｸﾋﾞｰ",
          ShortOfPointDiv: 0,
          EcOnlyFlg: "0",
          ConsumeTaxRate: 8,
          CoopPointRateList: [
            {
              ItemCode: "2345678",
              CoopCode: "142",
              ThisTimeSupplyPrice: 200000000,
              PointRate: "20",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "48500"
            },
            {
              ItemCode: "2345678",
              CoopCode: "163",
              ThisTimeSupplyPrice: 2000,
              PointRate: "20",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "48501"
            },
            {
              ItemCode: "2345678",
              CoopCode: "185",
              ThisTimeSupplyPrice: 2000,
              PointRate: "10",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "48502"
            },
            {
              ItemCode: "2345678",
              CoopCode: "240",
              ThisTimeSupplyPrice: 2000,
              PointRate: "20",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "48503"
            },
            {
              ItemCode: "2345678",
              CoopCode: "210",
              ThisTimeSupplyPrice: 2000,
              PointRate: "20",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "44404"
            },
            {
              ItemCode: "2345678",
              CoopCode: "302",
              ThisTimeSupplyPrice: 2000,
              PointRate: "20",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "48505"
            },
            {
              ItemCode: "2345678",
              CoopCode: "515",
              ThisTimeSupplyPrice: 2000,
              PointRate: "20",
              PointExchangeEquivalentAmount: "441",
              ExchangePoints: "48506"
            },
          ]
        }
      ]
    }
  }
}

const getPlanGoodsPointExchangePromotionResponseFlgOff = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      PointPromotionFlg: 0,
      PointExchangeList: []
    }
  }
}

const getPlanGoodsNvalPromotionResponseFlgOn = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      NvalPromotionFlg: 1,
      OrderCodeList: [
        "2023310",
        "2023320",
        "2023330",
      ],
      NvalPromotionVOList: [
        {
          OrderCode: "2023310",
          NvalDetailId: 76126,
          MediumType: "041",
          MediumName: "いつでも注文　食品",
          ItemCode: "1234567",
          NvalOrderNumQuotaCode: "965",
          NvalOrderNum: "",
          IbnkssaKb: "XX1",
          ShkkktantKb: "2",
          NvalGoodsName: "ハウスみかん",
          NvalGoodsNameKana: "",
          NvalGuideName: "５００ｇ（４～８個）",
          NvalGuideNameKana: "",
          DiscountType: "1",
          DiscountRate: "",
          DiscountUnitPrice: "90",
          SupplyPriceStandard: 980,
          NvalDiscountSupplyUnitPrice: "890",
          PricePattern: 0,
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 1,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 1,
          UsePrefecture7Flg: 1,
          UsePrefecture8Flg: 1,
          Remarks: "",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          OrderCode: "2023310",
          NvalDetailId: 76127,
          MediumType: "041",
          MediumName: "いつでも注文　食品",
          ItemCode: "2345678",
          NvalOrderNumQuotaCode: "965",
          NvalOrderNum: "",
          IbnkssaKb: "XX2",
          ShkkktantKb: "2",
          NvalGoodsName: "ハウスみかん",
          NvalGoodsNameKana: "",
          NvalGuideName: "",
          NvalGuideNameKana: "",
          DiscountType: "0",
          DiscountRate: "",
          DiscountUnitPrice: "",
          SupplyPriceStandard: 980,
          PricePattern: 1,
          NvalDiscountSupplyUnitPrice: "980",
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 1,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 1,
          UsePrefecture7Flg: 1,
          UsePrefecture8Flg: 1,
          Remarks: "",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          OrderCode: "2023320",
          NvalDetailId: 76126,
          MediumType: "041",
          MediumName: "いつでも注文　食品",
          ItemCode: "1234567",
          NvalOrderNumQuotaCode: "965",
          NvalOrderNum: "073142",
          IbnkssaKb: "00",
          ShkkktantKb: "2",
          NvalGoodsName: "ハウスみかん",
          NvalGoodsNameKana: "",
          NvalGuideName: "",
          NvalGuideNameKana: "",
          DiscountType: "0",
          DiscountRate: "",
          DiscountUnitPrice: "",
          SupplyPriceStandard: 980,
          NvalDiscountSupplyUnitPrice: "980",
          PricePattern: 1,
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 1,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 1,
          UsePrefecture7Flg: 1,
          UsePrefecture8Flg: 1,
          Remarks: "",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          OrderCode: "2023320",
          NvalDetailId: 76127,
          MediumType: "041",
          MediumName: "いつでも注文　食品",
          ItemCode: "2345678",
          NvalOrderNumQuotaCode: "965",
          NvalOrderNum: "",
          IbnkssaKb: "00",
          ShkkktantKb: "2",
          NvalGoodsName: "ハウスみかん",
          NvalGoodsNameKana: "",
          NvalGuideName: "",
          NvalGuideNameKana: "",
          DiscountType: "0",
          DiscountRate: "",
          DiscountUnitPrice: "",
          SupplyPriceStandard: 980,
          NvalDiscountSupplyUnitPrice: "980",
          PricePattern: 1,
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 1,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 1,
          UsePrefecture7Flg: 1,
          UsePrefecture8Flg: 1,
          Remarks: "",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          OrderCode: "2023330",
          NvalDetailId: 76126,
          MediumType: "041",
          MediumName: "いつでも注文　食品",
          ItemCode: "1234567",
          NvalOrderNumQuotaCode: "965",
          NvalOrderNum: "073142",
          IbnkssaKb: "00",
          ShkkktantKb: "2",
          NvalGoodsName: "ハウスみかん",
          NvalGoodsNameKana: "",
          NvalGuideName: "",
          NvalGuideNameKana: "",
          DiscountType: "0",
          DiscountRate: "",
          DiscountUnitPrice: "",
          SupplyPriceStandard: 980,
          NvalDiscountSupplyUnitPrice: "980",
          PricePattern: 1,
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 1,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 1,
          UsePrefecture7Flg: 1,
          UsePrefecture8Flg: 1,
          Remarks: "",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          OrderCode: "2023330",
          NvalDetailId: 76127,
          MediumType: "041",
          MediumName: "いつでも注文　食品",
          ItemCode: "2345678",
          NvalOrderNumQuotaCode: "965",
          NvalOrderNum: "",
          IbnkssaKb: "00",
          ShkkktantKb: "2",
          NvalGoodsName: "ハウスみかん",
          NvalGoodsNameKana: "",
          NvalGuideName: "",
          NvalGuideNameKana: "",
          DiscountType: "0",
          DiscountRate: "",
          DiscountUnitPrice: "",
          SupplyPriceStandard: 980,
          NvalDiscountSupplyUnitPrice: "980",
          PricePattern: 1,
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 1,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 1,
          UsePrefecture7Flg: 1,
          UsePrefecture8Flg: 1,
          Remarks: "",
          RegistFlg: "0",
          DeleteFlg: "0"
        }
      ],
      BundlePeriodVOList: [
        {
          MediumType: "041",
          StartOrderCode: "202310",
          EndOrderCode: "2023330"
        }
      ]
    }
  }
}

const getPlanGoodsNvalPromotionResponseNameNull = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      NvalPromotionFlg: 1,
      OrderCodeList: [
        "2023310",
        "2023320",
        "2023330",
        "2023340",
        "2023350",
        "2023360",
        "2023370"
      ],
      NvalPromotionVOList: [
        {
          NvalDetailId: 1,
          OrderCode: "2023310",
          MediumType: "001",
          MediumName: "媒体名",
          ItemCode: 1234567,
          NvalOrderNumQuotaCode: "004",
          NvalOrderNum: "100",
          IbnkssaKb: "001",
          ShkkktantKb: "1",
          NvalGoodsName: "XXXXXXXXXXXXXX",
          NvalGoodsNameKana: "XXXXXXXXXXXXXXX",
          NvalGuideName: "XXXXXXXXXXXXXXX",
          NvalGuideNameKana: "XXXXXXXXXX",
          DiscountType: "0",
          DiscountUnitPrice: "",
          DiscountRate: "",
          SupplyPriceStandard: 1000,
          NvalDiscountSupplyUnitPrice: "1000",
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 0,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 0,
          UsePrefecture7Flg: 0,
          UsePrefecture8Flg: 0,
          Remarks: "XXXXXXXXXXXXXX",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          NvalDetailId: 1,
          OrderCode: "2023320",
          MediumType: "001",
          MediumName: "媒体名",
          ItemCode: 1234567,
          NvalOrderNumQuotaCode: "004",
          NvalOrderNum: "100",
          IbnkssaKb: "001",
          ShkkktantKb: "1",
          NvalGoodsName: "XXXXXXXXXXXXXX",
          NvalGoodsNameKana: "XXXXXXXXXXXXXXX",
          NvalGuideName: "XXXXXXXXXXXXXXX",
          NvalGuideNameKana: "XXXXXXXXXX",
          DiscountType: "1",
          DiscountUnitPrice: "167",
          DiscountRate: "",
          SupplyPriceStandard: 1234567,
          NvalDiscountSupplyUnitPrice: "1234567",
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 0,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 0,
          UsePrefecture7Flg: 0,
          UsePrefecture8Flg: 0,
          Remarks: "XXXXXXXXXXXXXX",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          NvalDetailId: 1,
          OrderCode: "2023330",
          MediumType: "001",
          MediumName: "媒体名",
          ItemCode: 1234567,
          NvalOrderNumQuotaCode: "004",
          NvalOrderNum: "100",
          IbnkssaKb: "001",
          ShkkktantKb: "1",
          NvalGoodsName: "XXXXXXXXXXXXXX",
          NvalGoodsNameKana: "XXXXXXXXXXXXXXX",
          NvalGuideName: "XXXXXXXXXXXXXXX",
          NvalGuideNameKana: "XXXXXXXXXX",
          DiscountType: "1",
          DiscountUnitPrice: "1233567",
          DiscountRate: "",
          SupplyPriceStandard: 1234567,
          NvalDiscountSupplyUnitPrice: "1000",
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 0,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 0,
          UsePrefecture7Flg: 0,
          UsePrefecture8Flg: 0,
          Remarks: "備考",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          NvalDetailId: 2,
          OrderCode: "2023320",
          MediumType: "001",
          MediumName: "媒体名",
          ItemCode: 1234567,
          NvalOrderNumQuotaCode: "004",
          NvalOrderNum: "12",
          IbnkssaKb: "001",
          ShkkktantKb: "1",
          NvalGoodsName: "XXXXXXXXXXXXXX",
          NvalGoodsNameKana: "XXXXXXXXXXXXXXX",
          NvalGuideName: "XXXXXXXXXXXXXXX",
          NvalGuideNameKana: "XXXXXXXXXX",
          DiscountType: "1",
          DiscountUnitPrice: "1233567",
          DiscountRate: "",
          SupplyPriceStandard: 1234567,
          NvalDiscountSupplyUnitPrice: "1000",
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 0,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 0,
          UsePrefecture7Flg: 0,
          UsePrefecture8Flg: 0,
          Remarks: "備考",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          NvalDetailId: 2,
          OrderCode: "2023330",
          MediumType: "001",
          MediumName: "媒体名",
          ItemCode: 1234567,
          NvalOrderNumQuotaCode: "005",
          NvalOrderNum: "12",
          IbnkssaKb: "001",
          ShkkktantKb: "1",
          NvalGoodsName: "XXXXXXXXXXXXXX",
          NvalGoodsNameKana: "XXXXXXXXXXXXXXX",
          NvalGuideName: "XXXXXXXXXXXXXXX",
          NvalGuideNameKana: "XXXXXXXXXXXXXXX",
          DiscountType: "2",
          DiscountUnitPrice: "1234567",
          DiscountRate: "10",
          SupplyPriceStandard: 1234567,
          NvalDiscountSupplyUnitPrice: "1234567",
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 0,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 0,
          UsePrefecture7Flg: 0,
          UsePrefecture8Flg: 0,
          Remarks: "XXXXXXXXXXXXXX",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          NvalDetailId: 2,
          OrderCode: "2023340",
          MediumType: "001",
          MediumName: "媒体名",
          ItemCode: 1234567,
          NvalOrderNumQuotaCode: "004",
          NvalOrderNum: "12",
          IbnkssaKb: "001",
          ShkkktantKb: "1",
          NvalGoodsName: "2023340goods",
          NvalGoodsNameKana: "XXXXXXXXXXXXXXX",
          NvalGuideName: "2023340guide",
          NvalGuideNameKana: "XXXXXXXXXXXXXXX",
          DiscountType: "1",
          DiscountUnitPrice: "1234567",
          DiscountRate: "123",
          SupplyPriceStandard: 1234567,
          NvalDiscountSupplyUnitPrice: "1234567",
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 0,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 0,
          UsePrefecture7Flg: 0,
          UsePrefecture8Flg: 0,
          Remarks: "XXXXXXXXXXXXXX",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          NvalDetailId: 3,
          OrderCode: "2023320",
          MediumType: "002",
          MediumName: "媒体名2",
          ItemCode: 1234567,
          NvalOrderNumQuotaCode: "005",
          NvalOrderNum: "123",
          IbnkssaKb: "002",
          ShkkktantKb: "1",
          NvalGoodsName: "XXXXXXXXXXXXXX",
          NvalGoodsNameKana: "XXXXXXXXXXXXXXX",
          NvalGuideName: "XXXXXXXXXXXXXXX",
          NvalGuideNameKana: "XXXXXXXXXXXXXXX",
          DiscountType: "1",
          DiscountUnitPrice: "1234567",
          DiscountRate: "123",
          SupplyPriceStandard: 1234567,
          NvalDiscountSupplyUnitPrice: "1234567",
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 0,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 0,
          UsePrefecture7Flg: 0,
          UsePrefecture8Flg: 0,
          Remarks: "XXXXXXXXXXXXXX",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          NvalDetailId: 3,
          OrderCode: "2023330",
          MediumType: "002",
          MediumName: "媒体名2",
          ItemCode: 1234567,
          NvalOrderNumQuotaCode: "006",
          NvalOrderNum: "123",
          IbnkssaKb: "002",
          ShkkktantKb: "1",
          NvalGoodsName: "XXXXXXXXXXXXXX",
          NvalGoodsNameKana: "XXXXXXXXXXXXXXX",
          NvalGuideName: "XXXXXXXXXXXXXXX",
          NvalGuideNameKana: "XXXXXXXXXXXXXXX",
          DiscountType: "2",
          DiscountUnitPrice: "",
          DiscountRate: "10",
          SupplyPriceStandard: 1234567,
          NvalDiscountSupplyUnitPrice: "1234567",
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 0,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 0,
          UsePrefecture7Flg: 0,
          UsePrefecture8Flg: 0,
          Remarks: "XXXXXXXXXXXXXX",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
        {
          NvalDetailId: 4,
          OrderCode: "2023330",
          MediumType: "003",
          MediumName: "媒体名2",
          ItemCode: 1234567,
          NvalOrderNumQuotaCode: "006",
          NvalOrderNum: "123",
          IbnkssaKb: "002",
          ShkkktantKb: "1",
          NvalGoodsName: "XXXXXXXXXXXXXX",
          NvalGoodsNameKana: "XXXXXXXXXXXXXXX",
          NvalGuideName: "XXXXXXXXXXXXXXX",
          NvalGuideNameKana: "XXXXXXXXXXXXXXX",
          DiscountType: "2",
          DiscountUnitPrice: "",
          DiscountRate: "10",
          SupplyPriceStandard: 1234567,
          NvalDiscountSupplyUnitPrice: "1234567",
          UsePrefecture1Flg: 1,
          UsePrefecture2Flg: 1,
          UsePrefecture3Flg: 1,
          UsePrefecture4Flg: 0,
          UsePrefecture5Flg: 1,
          UsePrefecture6Flg: 0,
          UsePrefecture7Flg: 0,
          UsePrefecture8Flg: 0,
          Remarks: "XXXXXXXXXXXXXX",
          RegistFlg: "0",
          DeleteFlg: "0"
        },
      ],
      BundlePeriodVOList: [
        {
          MediumType: "001",
          StartOrderCode: "2023310",
          EndOrderCode: "2023330"
         },
        {
          MediumType: "002",
          StartOrderCode: "2023320",
          EndOrderCode: "2023320"
        },
        {
          MediumType: "003",
          StartOrderCode: "2023340",
          EndOrderCode: "2023340"
        }
      ]
    }
  }
}

const getPlanGoodsNvalPromotionResponseFlgOff = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      NvalPromotionFlg: 0,
      OrderCodeList: [],
      NvalPromotionVOList: [],
      BundlePeriodVOList: []
    }
  }
}

const getPlanGoodsCouponPromotionResponseFlgOn = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      CouponPromotionFlg: 1,
      CouponPromotionVOList: [
        {
          CouponGoodsNo: "000000001",
          ItemCode: "1234567",
          CouponType: "01",
          CouponTypeName: "２名グループ利用値引",
          GroupType: "A",
          CouponOrderNumQuotaCode: "007",
          CouponOrderNum: "123456",
          NotificationFlg: "1",
          NotificationFlgName: "通知有",
          DeliveryFlg: 1,
          DeliveryFlgName: "有",
          NewsletterFlg: 1,
          NewsletterFlgName: "有",
          StandardUsageAmount: "1234567",
          StartMembershipWeeks: "1",
          // StartMembershipWeeks: null,
          EndMembershipWeeks: "98",
          // EndMembershipWeeks: null,
          // EndMembershipWeeks: "99",
          CouponName: "クーポンA",
          CouponNameKana: "ｸｰﾎﾟﾝｴｰ",
          CouponGuideName: "キカクA",
          CouponGuideNameKana: "ｷｶｸｴｰ",
          CouponTitleEc: "タイトルEC",
          CouponTitleDelivery: "",
          ContentOne: "商品名・規格",
          ContentTwo: "本体　５６０円（税込　６０４円）",
          // ContentTwo: "",
          ContentThree: "１００円引きクーポン",
          // ContentThree: "",
          ContentFour: "本体　４６０円（税込　４９６円）",
          // ContentFour: "",
          ValidatedDate: "２０２５年１０月４回のご注文のみ有効",
          StaffCouponFlg: "0",
          RegistFlg: "0",
          DeleteFlg: "0",
          CouponApplicablePriceList: [
            {
              CoopCode: "142",
              PlanGoodsCoopCouponApplicablePriceFlg: "1",
              ThisTimeSupplyPrice: 5600,
              DiscountUnitPrice: "10",
              DiscountRate: "",
              LimitNum: "12",
              CouponDiscountSupplyUnitPrice: "5590",
            },
            {
              CoopCode: "163",
              PlanGoodsCoopCouponApplicablePriceFlg: "1",
              ThisTimeSupplyPrice: null,
              DiscountUnitPrice: "100",
              DiscountRate: "",
              LimitNum: "34",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
            {
              CoopCode: "185",
              PlanGoodsCoopCouponApplicablePriceFlg: "1",
              ThisTimeSupplyPrice: 560,
              DiscountUnitPrice: "",
              DiscountRate: "",
              LimitNum: "56",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
            // {
            //   CoopCode: "240",
            //   PlanGoodsCoopCouponApplicablePriceFlg: "0",
            //   ThisTimeSupplyPrice: 560,
            //   DiscountUnitPrice: "100",
            //   DiscountRate: "",
            //   LimitNum: "1234567",
            //   CouponDiscountSupplyUnitPrice: "1234567",
            // },
            {
              CoopCode: "210",
              PlanGoodsCoopCouponApplicablePriceFlg: "1",
              ThisTimeSupplyPrice: 560,
              DiscountUnitPrice: "100",
              DiscountRate: "",
              LimitNum: "78",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
            {
              CoopCode: "302",
              PlanGoodsCoopCouponApplicablePriceFlg: "0",
              ThisTimeSupplyPrice: 560,
              DiscountUnitPrice: "100",
              DiscountRate: "",
              LimitNum: "1234567",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
            {
              CoopCode: "515",
              PlanGoodsCoopCouponApplicablePriceFlg: "0",
              ThisTimeSupplyPrice: 560,
              DiscountUnitPrice: "100",
              DiscountRate: "",
              LimitNum: "1234567",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
            {
              CoopCode: "451",
              PlanGoodsCoopCouponApplicablePriceFlg: "0",
              ThisTimeSupplyPrice: 560,
              DiscountUnitPrice: "100",
              DiscountRate: "",
              LimitNum: "1234567",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
          ]
        },{
          CouponGoodsNo: "000000002",
          ItemCode: "2345678",
          CouponType: "",
          CouponTypeName: "",
          GroupType: "9",
          CouponOrderNumQuotaCode: "007",
          CouponOrderNum: "123456",
          NotificationFlg: "",
          NotificationFlgName: "",
          DeliveryFlg: null,
          DeliveryFlgName: "",
          NewsletterFlg: null,
          NewsletterFlgName: "",
          StandardUsageAmount: "1234567",
          // StartMembershipWeeks: "1",
          StartMembershipWeeks: null,
          // EndMembershipWeeks: "98",
          EndMembershipWeeks: null,
          // EndMembershipWeeks: "99",
          CouponName: "",
          CouponNameKana: "",
          CouponGuideName: "",
          CouponGuideNameKana: "",
          CouponTitleEc: "タイトルEC",
          CouponTitleDelivery: "タイトルお届け明細",
          // ContentOne: "クーポンA　キカクA",
          ContentOne: "",
          // ContentTwo: "本体　５６０円（税込　６０４円）",
          ContentTwo: "",
          // ContentThree: "１００円引きクーポン",
          ContentThree: "",
          ContentFour: "本体　４６０円（税込　４９６円）",
          // ContentFour: "",
          ValidatedDate: "２０２５年１０月４回のご注文のみ有効",
          StaffCouponFlg: "1",
          RegistFlg: "0",
          DeleteFlg: "0",
          CouponApplicablePriceList: [
            {
              CoopCode: "142",
              PlanGoodsCoopCouponApplicablePriceFlg: "0",
              ThisTimeSupplyPrice: null,
              DiscountUnitPrice: "",
              DiscountRate: "10",
              LimitNum: "1234567",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
            {
              CoopCode: "163",
              PlanGoodsCoopCouponApplicablePriceFlg: "0",
              ThisTimeSupplyPrice: 460,
              DiscountUnitPrice: "100",
              DiscountRate: "",
              LimitNum: "1234567",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
            {
              CoopCode: "185",
              PlanGoodsCoopCouponApplicablePriceFlg: "0",
              ThisTimeSupplyPrice: null,
              DiscountUnitPrice: "",
              DiscountRate: "",
              LimitNum: "1234567",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
            {
              CoopCode: "240",
              PlanGoodsCoopCouponApplicablePriceFlg: "1",
              ThisTimeSupplyPrice: 100,
              DiscountUnitPrice: "",
              DiscountRate: "10",
              LimitNum: "1234567",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
            {
              CoopCode: "210",
              PlanGoodsCoopCouponApplicablePriceFlg: "0",
              ThisTimeSupplyPrice: null,
              DiscountUnitPrice: "100",
              DiscountRate: "",
              LimitNum: "1234567",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
            {
              CoopCode: "302",
              PlanGoodsCoopCouponApplicablePriceFlg: "1",
              ThisTimeSupplyPrice: 160,
              DiscountUnitPrice: "100",
              DiscountRate: "",
              LimitNum: "1234567",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
            {
              CoopCode: "515",
              PlanGoodsCoopCouponApplicablePriceFlg: "0",
              ThisTimeSupplyPrice: null,
              DiscountUnitPrice: "100",
              DiscountRate: "",
              LimitNum: "1234567",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
            {
              CoopCode: "451",
              PlanGoodsCoopCouponApplicablePriceFlg: "0",
              ThisTimeSupplyPrice: 110,
              DiscountUnitPrice: "100",
              DiscountRate: "",
              LimitNum: "1234567",
              CouponDiscountSupplyUnitPrice: "1234567",
            },
          ]
        },
      ]
    }
  }
}

const getPlanGoodsCouponPromotionResponseFlgOnNameNull = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      CouponPromotionFlg: 1,
      CouponType: "0",
      GroupType: "0",
      CouponOrderNumQuotaCode: "008",
      CouponOrderNum: "123456",
      NotificationFlg: "0",
      DeliveryFlg: 0,
      NewsletterFlg: 0,
      StandardUsageAmount: "1234567",
      StartMembershipWeeks: "1",
      EndMembershipWeeks: "99",
      CouponName: "",
      CouponNameKana: "",
      CouponGuideName: "",
      CouponGuideNameKana: "",
      CouponTitleEc: "タイトルEC",
      CouponTitleDelivery: "タイトルお届け明細",
      ContentOne: "",
      ContentTwo: "",
      ContentThree: "",
      ContentFour: "",
      ValidatedDate: "２０２５年１０月４回のご注文のみ有効",
      StaffCouponFlg: "0",
      CouponApplicablePriceList: [
        {
          CoopCode: "142",
          PlanGoodsCoopCouponApplicablePriceFlg: "0",
          ThisTimeSupplyPrice: 1000,
          DiscountUnitPrice: "",
          DiscountRate: "10",
          LimitNum: "1234567",
        },
        {
          CoopCode: "163",
          PlanGoodsCoopCouponApplicablePriceFlg: "1",
          ThisTimeSupplyPrice: 1000,
          DiscountUnitPrice: "100",
          DiscountRate: "",
          LimitNum: "1234567",
        },
        {
          CoopCode: "185",
          PlanGoodsCoopCouponApplicablePriceFlg: "0",
          ThisTimeSupplyPrice: 1000,
          DiscountUnitPrice: "",
          DiscountRate: "100",
          LimitNum: "1234567",
        },
        {
          CoopCode: "240",
          PlanGoodsCoopCouponApplicablePriceFlg: "1",
          ThisTimeSupplyPrice: 1000000,
          DiscountUnitPrice: "",
          DiscountRate: "20",
          LimitNum: "1234567",
        },
        {
          CoopCode: "210",
          PlanGoodsCoopCouponApplicablePriceFlg: "0",
          ThisTimeSupplyPrice: 2000,
          DiscountUnitPrice: "100",
          DiscountRate: "",
          LimitNum: "1234567",
        },
        {
          CoopCode: "302",
          PlanGoodsCoopCouponApplicablePriceFlg: "1",
          ThisTimeSupplyPrice: 1500,
          DiscountUnitPrice: "100",
          DiscountRate: "",
          LimitNum: "1234567",
        },
        {
          CoopCode: "515",
          PlanGoodsCoopCouponApplicablePriceFlg: "0",
          ThisTimeSupplyPrice: 1000,
          DiscountUnitPrice: "100",
          DiscountRate: "",
          LimitNum: "1234567",
        },
        {
          CoopCode: "451",
          PlanGoodsCoopCouponApplicablePriceFlg: "1",
          ThisTimeSupplyPrice: 2000,
          DiscountUnitPrice: "100",
          DiscountRate: "",
          LimitNum: "1234567",
        },
      ]
    }
  }
}

const getPlanGoodsCouponPromotionResponseFlgOff = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      CouponPromotionFlg: 0,
      CouponPromotionVOList: []
    }
  }
}

const getPreOrderFlagResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      // PreOrderFlag: 0,
      PreOrderFlag: 1,
    }
  }
}

const getPreOrderResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      PreOrderList: [
        {
          PreOrderDetailId: 1,
          ItemCode: "1234567",
          PreOrderNumQuotaCode: "123",
          PreOrderNum: "123456",
          DelivCatalogId: "12345678",
          DelivMonday: 0,
          DelivTuesday: 0,
          DelivWednesday: 0,
          DelivThursday: 0,
          DelivFriday: 0,
          PreOrderGoodsName: "商品名１",
          PreOrderGoodsNameKana: "ショウヒンメイ１",
          PreOrderStandardName: "規格名１",
          PreOrderStandardNameKana: "キカクメイ１",
          DiscountType: "0",
          DiscountUnitPrice: "",
          DiscountRate: "",
          DiscountSupplyUnitPrice: "",
          PreOrderPoints: "100",
          SetPreOrderType: "0",
          PricePattern: 0,
          SupplyUnitPrice: 11111,
          PreOrderCoopList: [
            {
              CoopCode: "142",
              PlanNum: 12345678,
            },
            {
              CoopCode: "210",
              PlanNum: 23456789,
            },
            {
              CoopCode: "515",
              PlanNum: 23456789,
            },
          ]
        },
        {
          PreOrderDetailId: 1,
          ItemCode: "2345678",
          PreOrderNumQuotaCode: "234",
          PreOrderNum: "234567",
          DelivCatalogId: "23456789",
          DelivMonday: 0,
          DelivTuesday: 0,
          DelivWednesday: 1,
          DelivThursday: 1,
          DelivFriday: 1,
          PreOrderGoodsName: "商品名２",
          PreOrderGoodsNameKana: "ショウヒンメイ２",
          PreOrderStandardName: "規格名２",
          PreOrderStandardNameKana: "キカクメイ２",
          DiscountType: "1",
          DiscountUnitPrice: "2345678",
          DiscountRate: "",
          DiscountSupplyUnitPrice: "677345",
          PreOrderPoints: "200",
          SetPreOrderType: "0",
          PricePattern: 1,
          SupplyUnitPrice: 22222,
          PreOrderCoopList: [
            {
              CoopCode: "451",
              PlanNum: 12345678,
            },
            {
              CoopCode: "302",
              PlanNum: 30230230,
            }
          ]
        },
        {
          PreOrderDetailId: 2,
          ItemCode: "1234567",
          PreOrderNumQuotaCode: "234",
          PreOrderNum: "234567",
          DelivCatalogId: "23456789",
          DelivMonday: 1,
          DelivTuesday: 1,
          DelivWednesday: 1,
          DelivThursday: 1,
          DelivFriday: 1,
          PreOrderGoodsName: "商品名３",
          PreOrderGoodsNameKana: "ショウヒンメイ３",
          PreOrderStandardName: "規格名３",
          PreOrderStandardNameKana: "キカクメイ３",
          DiscountType: "2",
          DiscountUnitPrice: "",
          DiscountRate: "20",
          DiscountSupplyUnitPrice: "987654",
          PreOrderPoints: "200",
          SetPreOrderType: "0",
          PricePattern: 2,
          SupplyUnitPrice: 3333,
          PreOrderCoopList: [
            {
              CoopCode: "163",
              PlanNum: 12345678,
            },
          ]
        },
        {
          PreOrderDetailId: 2,
          ItemCode: "2345678",
          PreOrderNumQuotaCode: "234",
          PreOrderNum: "234567",
          DelivCatalogId: "23456789",
          DelivMonday: 0,
          DelivTuesday: 0,
          DelivWednesday: 0,
          DelivThursday: 1,
          DelivFriday: 1,
          PreOrderGoodsName: "商品名３",
          PreOrderGoodsNameKana: "ショウヒンメイ３",
          PreOrderStandardName: "規格名３",
          PreOrderStandardNameKana: "キカクメイ３",
          DiscountType: "0",
          DiscountUnitPrice: "",
          DiscountRate: "",
          DiscountSupplyUnitPrice: "",
          PreOrderPoints: "200",
          SetPreOrderType: "1",
          PricePattern: 3,
          SupplyUnitPrice: null,
          PreOrderCoopList: [
            {
              CoopCode: "210",
              PlanNum: 123,
            },
          ]
        }
      ]
    }
  }
}

const getPlanGoodsECResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      CmFlg: "1",
      RecommendFlg: "1",
      OrderLimitFlg: "1",
      WebLimitFlg: "1",
      RecommendCommentFlg: "1",
      OrderGoodsDiv: "6",
      MinOrderNum: 10,
      // MinOrderNum: null,
      MaxOrderNum: 100,
      NonDispFlg: "1",
    }
  }
}

const getImageDataResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      ImageList: [
        {
          CoopCode: "142",
          CoopImageList: [
            {
              ImageId: 123456789,
              ImageName: "XXXXXXXXX",
              ImageFileName: "XXXXXXXXXXXX",
              StartOrderCode: "1234567",
              ShowSeq: 123,
              ImagePreviewUrl: "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
              TextCaption: "XXXXXXXXX"
            },
            {
              ImageId: 123456789,
              ImageName: "XXXXXXXXX",
              ImageFileName: "XXXXXXXXXXXX",
              StartOrderCode: "1234567",
              ShowSeq: 123,
              ImagePreviewUrl: "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
              TextCaption: "XXXXXXXXX"
            },
            {
              ImageId: 123456789,
              ImageName: "XXXXXXXXX",
              ImageFileName: "XXXXXXXXXXXX",
              StartOrderCode: "1234567",
              ShowSeq: 123,
              ImagePreviewUrl: "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
              TextCaption: "XXXXXXXXX"
            },
            {
              ImageId: 123456789,
              ImageName: "XXXXXXXXX",
              ImageFileName: "XXXXXXXXXXXX",
              StartOrderCode: "1234567",
              ShowSeq: 123,
              ImagePreviewUrl: "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
              TextCaption: "XXXXXXXXX"
            },
            {
              ImageId: 123456789,
              ImageName: "XXXXXXXXX",
              ImageFileName: "XXXXXXXXXXXX",
              StartOrderCode: "1234567",
              ShowSeq: 123,
              ImagePreviewUrl: "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
              TextCaption: "XXXXXXXXX"
            },
          ]
        },
        {
          CoopCode: "163",
          CoopImageList: [
            {
              ImageId: 123456789,
              ImageName: "XXXXXXXXX",
              ImageFileName: "XXXXXXXXXXXX",
              StartOrderCode: "1234567",
              ShowSeq: 123,
              ImagePreviewUrl: "http://127.0.0.1:8083/N_PEACE/file/mark//001_01.png?20250106143205",
              TextCaption: "XXXXXXXXX"
            },
          ]
        },
        {
          CoopCode: "185",
          CoopImageList: [
          ]
        },
        {
          CoopCode: "240",
          CoopImageList: [
          ]
        },
        {
          CoopCode: "210",
          CoopImageList: [
          ]
        },
        {
          CoopCode: "302",
          CoopImageList: [
          ]
        },
        {
          CoopCode: "515",
          CoopImageList: [
          ]
        },
        {
          CoopCode: "451",
          CoopImageList: [
          ]
        },
      ],
      EnableCoopList: [
        {
          CoopCode: "142"
        },
        {
          CoopCode: "163"
        },
        {
          CoopCode: "185"
        },
        {
          CoopCode: "240"
        },
        {
          CoopCode: "210"
        },
        {
          CoopCode: "302"
        },
        {
          CoopCode: "515"
        },
        // {
        //   CoopCode: "451"
        // },
      ]
    }
  }
}

const getStockInfoResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      // StockLimitFlg: 1,
      StockLimitFlg: 0,
      StockNumTotal: 450,
      StockNumShowFlg: "1",
      BrandName: "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
      StockList: [
        {
          CoopCode: "142",
          StockNum: 200,
          SupplyPrice: null,
          SupplyPriceExplanation: ""
        },
        {
          CoopCode: "163",
          StockNum: 250,
          SupplyPrice: null,
          SupplyPriceExplanation: ""
        },
        {
          CoopCode: "185",
          StockNum: null,
          SupplyPrice: null,
          SupplyPriceExplanation: ""
        },
        {
          CoopCode: "240",
          StockNum: null,
          SupplyPrice: null,
          SupplyPriceExplanation: ""
        },
        {
          CoopCode: "210",
          StockNum: null,
          SupplyPrice: null,
          SupplyPriceExplanation: ""
        },
        {
          CoopCode: "302",
          StockNum: null,
          SupplyPrice: null,
          SupplyPriceExplanation: ""
        },
        {
          CoopCode: "515",
          StockNum: null,
          SupplyPrice: null,
          SupplyPriceExplanation: ""
        },
        {
          CoopCode: "451",
          StockNum: null,
          SupplyPrice: null,
          SupplyPriceExplanation: ""
        },
      ]
    }
  }
}

const getGroupingInfoResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      GroupingCode: "701",
      GroupingName: "７（茨,栃,群,千,埼,東,長）",
      GroupingDivIBK: "A",
      GroupingDivTTG: "A",
      GroupingDivGNM: "A",
      GroupingDivTIB: "A",
      GroupingDivSTM: "A",
      GroupingDivTYO: "A",
      GroupingDivNGN: "A",
      GroupingDivNGT: "A",
      Remarks: "XXXXXXXXXXX",
    }
  }
}

const getWebLinkInfoResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      CoopGoodsUrlTitle: "ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ",
      CoopGoodsUrl: "https://www.xxx.coopdeli.jp/xxxx/wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww",
      // CoopGoodsUrl: "",
      RelatedUrlTitle: "A",
      RelatedUrl: "A",
      // RelatedUrl: "",
    }
  }
}

const getGroupingListResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      {
        GroupingCode: "701",
        GroupingName: "７（茨,栃,群,千,埼,東,長）"
      },
      {
        GroupingCode: "601",
        GroupingName: "６（茨,栃,群,千,埼,東）"
      }
    ]
  }
}

const getGroupingDataResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      GroupingCode: "601",
      GroupingName: "６（茨,栃,群,千,埼,東）",
      Remarks: "XXXXXXXXXXX",
      GroupingDivIBK: "A",
      GroupingDivTTG: "A",
      GroupingDivGNM: "A",
      GroupingDivTIB: "A",
      GroupingDivSTM: "A",
      GroupingDivTYO: "A",
      GroupingDivNGN: "A",
      GroupingDivNGT: "A"
    }
  }
}

const getTagListResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      {
        TagGroupName: "タググループ1",
        TagName: "タグ1-1,タグ1-2,タグ1-3"
      },
      {
        TagGroupName: "タググループ2",
        TagName: "タグ2-1,タグ2-2"
      },
      {
        TagGroupName: "タググループ3",
        TagName: "タグ3-1"
      },
    ]
  }
}

const getCheckPlanGoodsResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: []
  }
}

const getNotUseCoopResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {}
  }
}

const getGoodsUseCoopResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      CoopCodeList: [
      {
        ItemCode: "1234567",
        CoopCode: "142"
      },
      {
        ItemCode: "1234567",
        CoopCode: "163"
      },
      {
        ItemCode: "1234567",
        CoopCode: "185"
      },
      {
        ItemCode: "1234567",
        CoopCode: "210"
      },
      {
        ItemCode: "2345678",
        CoopCode: "240"
      },
      {
        ItemCode: "2345678",
        CoopCode: "302"
      },
      {
        ItemCode: "3456789",
        CoopCode: "515"
      },
      ]
    }
  }
}
const getIconDataResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      IconCodeList: [
        {
          IconCode: "001"
        },
        {
          IconCode: "003"
        }
      ]
    }
  }
}

const getSelectedNvalMediumListResponse = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: [
      {
        MediumType: "041",
        MediumName: "媒体名1"
      },
      {
        MediumType: "042",
        MediumName: "媒体名2"
      }
    ]
  }
}

const getGoodsSupplyPriceResponse = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      CoopList: [
       {
        ItemCode: "1234567",
        CoopCode: "142",
        SupplyPriceStandard: 1200,
        SupplyPriceSpecial1: 1300,
        SupplyPriceSpecial2: 1400
       },
       {
        ItemCode: "1234567",
        CoopCode: "163",
        SupplyPriceStandard: 1500,
        SupplyPriceSpecial1: 1600,
        SupplyPriceSpecial2: 1700
       },
       {
        ItemCode: "2345678",
        CoopCode: "210",
        SupplyPriceStandard: 2300,
        SupplyPriceSpecial1: 2400,
        SupplyPriceSpecial2: 2500
       },
       {
        ItemCode: "2345678",
        CoopCode: "142",
        SupplyPriceStandard: 2600,
        SupplyPriceSpecial1: 2700,
        SupplyPriceSpecial2: 2800
       }
      ]
    }
  }
}